// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import {
//   Box,
//   Typography,
//   Card,
//   CardMedia,
//   CardContent,
//   Grid,
//   Button,
//   IconButton,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   DialogActions,
//   DialogContentText,
//   Chip,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
//   InputAdornment,
//   CircularProgress,
//   Paper,
//   Tabs,
//   Tab,
//   Stack,
//   Grow,
//   Popper,
//   ClickAwayListener
// } from '@mui/material';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import HotelIcon from '@mui/icons-material/Hotel';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import ElevatorIcon from '@mui/icons-material/Elevator';
// import VideocamIcon from '@mui/icons-material/Videocam';
// import ChildCareIcon from '@mui/icons-material/ChildCare';
// import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
// import HomeIcon from '@mui/icons-material/Home';
// import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
// import YardIcon from '@mui/icons-material/Yard';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import ShareIcon from '@mui/icons-material/Share';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import CloseIcon from '@mui/icons-material/Close';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
// import MovieIcon from '@mui/icons-material/Movie';
// import LocalParkingIcon from '@mui/icons-material/LocalParking';
// import PoolIcon from '@mui/icons-material/Pool';
// import PetsIcon from '@mui/icons-material/Pets';
// import AcUnitIcon from '@mui/icons-material/AcUnit';
// import TvIcon from '@mui/icons-material/Tv';
// import ChairIcon from '@mui/icons-material/Chair';
// import KitchenIcon from '@mui/icons-material/Kitchen';
// import WeekendIcon from '@mui/icons-material/Weekend';
// import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
// import MicrowaveIcon from '@mui/icons-material/Microwave';
// import PowerIcon from '@mui/icons-material/Power';
// import SecurityIcon from '@mui/icons-material/Security';
// import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
// import ParkIcon from '@mui/icons-material/Park';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import Loader from '../Loader/Loader';
// import { selectUser } from '../Commonlibs/userSlice';

// // Import amenity icons from PropertyDetails.jsx
// import liftIcon from '../assets/applift.png';
// import cctvIcon from '../assets/appctv.png';
// import gymIcon from '../assets/appfit.png';
// import gardenIcon from '../assets/appgarden.png';
// import kidsAreaIcon from '../assets/appkids.png';
// import sportsIcon from '../assets/appsport.png';
// import swimmingPoolIcon from '../assets/appswim.png';
// import intercomIcon from '../assets/appinter.png';
// import gatedCommunityIcon from '../assets/appgate.png';
// import clubHouseIcon from '../assets/appclub.png';
// import communityHallIcon from '../assets/appcom.png';
// import regularWaterSupplyIcon from '../assets/appregul.png';
// import powerBackupIcon from '../assets/apppower.png';
// import petAllowedIcon from '../assets/apppet.png';
// import diningTableIcon from '../assets/appdinner.png';
// import washingMachineIcon from '../assets/appwash.png';
// import sofaIcon from '../assets/appsofa.png';
// import microwaveIcon from '../assets/appmicro.png';
// import fridgeIcon from '../assets/appfridge.png';
// import waterPurifierIcon from '../assets/appwater.png';
// import gasPipelineIcon from '../assets/appgas.png';
// import acIcon from '../assets/appac.png';
// import bedIcon from '../assets/appbed.png';
// import tvIcon from '../assets/apptv.png';
// import cupboardIcon from '../assets/appcup.png';
// import geyserIcon from '../assets/appgeyser.png';

// // Define amenities data arrays matching PropertyDetails.jsx
// const societyAmenitiesData = [
//   { name: "Lift", icon: liftIcon, selected: false },
//   { name: "CCTV", icon: cctvIcon, selected: false },
//   { name: "Gym", icon: gymIcon, selected: false },
//   { name: "Garden", icon: gardenIcon, selected: false },
//   { name: "Kids Area", icon: kidsAreaIcon, selected: false },
//   { name: "Sports", icon: sportsIcon, selected: false },
//   { name: "Swimming Pool", icon: swimmingPoolIcon, selected: false },
//   { name: "Intercom", icon: intercomIcon, selected: false },
//   { name: "Gated Community", icon: gatedCommunityIcon, selected: false },
//   { name: "Club House", icon: clubHouseIcon, selected: false },
//   { name: "Community Hall", icon: communityHallIcon, selected: false },
//   { name: "Regular Water Supply", icon: regularWaterSupplyIcon, selected: false },
//   { name: "Power backup", icon: powerBackupIcon, selected: false },
//   { name: "Pet Allowed", icon: petAllowedIcon, selected: false },
// ];

// const furnishingFacilitiesData = [
//   { name: "Dining Table", icon: diningTableIcon, selected: false },
//   { name: "Washing Machine", icon: washingMachineIcon, selected: false },
//   { name: "Sofa", icon: sofaIcon, selected: false },
//   { name: "Microwave", icon: microwaveIcon, selected: false },
//   { name: "Fridge", icon: fridgeIcon, selected: false },
//   { name: "Water Purifier", icon: waterPurifierIcon, selected: false },
//   { name: "Gas Pipeline", icon: gasPipelineIcon, selected: false },
//   { name: "AC", icon: acIcon, selected: false },
//   { name: "Bed", icon: bedIcon, selected: false },
//   { name: "TV", icon: tvIcon, selected: false },
//   { name: "Cupboard", icon: cupboardIcon, selected: false },
//   { name: "Geyser", icon: geyserIcon, selected: false },
// ];

// const otherFacilitiesData = [
//   "Hospital",
//   "School",
//   "Park",
//   "Shopping Mall",
//   "Metro Station",
//   "Bus Stop",
//   "Restaurant",
//   "Pharmacy"
// ];

// const EditProperties = () => {
//   const { propertyId } = useParams();
//   const navigate = useNavigate();
//   const user = useSelector(selectUser);
  
//   const [loading, setLoading] = useState(true);
//   const [property, setProperty] = useState(null);
//   const [error, setError] = useState(null);
//   const [selectedMedia, setSelectedMedia] = useState(null);
//   const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
//   const [mediaType, setMediaType] = useState('image');
//   const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
//   const [editListingDialogOpen, setEditListingDialogOpen] = useState(false);
//   const [amenitiesDialogOpen, setAmenitiesDialogOpen] = useState(false);
//   const [editedProperty, setEditedProperty] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [alertDialog, setAlertDialog] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });
//   const [photosDialogOpen, setPhotosDialogOpen] = useState(false);
//   const [uploadedPhotos, setUploadedPhotos] = useState([]);
//   const [uploadedVideos, setUploadedVideos] = useState([]);
//   const [tabValue, setTabValue] = useState(0);
//   const [isUploading, setIsUploading] = useState(false);
//   const [userProfile, setUserProfile] = useState({
//     full_name: '',
//     email_id: '',
//     contact_number: '',
//     profile_image: null
//   });

//   // ✅ Helper function to check if a field has a valid value (not null, not empty string)
//   const hasValue = (value) => {
//     return value !== null && value !== undefined && value !== '';
//   };

//   // ✅ Check if amenities should be shown (only for residential non-plot/agriculture properties)
//   const shouldShowAmenities = () => {
//     if (!property) return false;
//     const propertyType = property.property_type?.toLowerCase();
//     const assetType = property.asset_type?.toLowerCase();
    
//     return propertyType === 'residential' &&
//            assetType !== 'plot' &&
//            assetType !== 'agriculture land';
//   };

//   // Function to get amenity icon
//   const getAmenityIcon = (amenityType) => {
//     const amenityIconMap = {
//       'Lift': ElevatorIcon,
//       'Parking': LocalParkingIcon,
//       'Gym': FitnessCenterIcon,
//       'Swimming Pool': PoolIcon,
//       'Garden': YardIcon,
//       'Playground': SportsSoccerIcon,
//       'Club House': HomeIcon,
//       'Indoor Games': SportsBaseballIcon,
//       'Jogging Track': SportsBaseballIcon,
//       'Security': SecurityIcon,
//       'Pet Allowed': PetsIcon,
//       'AC': AcUnitIcon,
//       'TV': TvIcon,
//       'Sofa': WeekendIcon,
//       'Bed': HotelIcon,
//       'Wardrobe': ChairIcon,
//       'Refrigerator': KitchenIcon,
//       'Washing Machine': LocalLaundryServiceIcon,
//       'Microwave': MicrowaveIcon,
//       'Power Backup': PowerIcon,
//       'CCTV': VideocamIcon,
//       'Children Area': ChildCareIcon,
//       'Modular Kitchen': KitchenIcon,
//       'Dining Table': WeekendIcon,
//       'Fire Safety': SecurityIcon,
//       'Visitor Parking': LocalParkingIcon,
//       'Water Supply': PoolIcon,
//       'Rainwater Harvesting': PoolIcon,
//       'Waste Disposal': DeleteIcon,
//       'Hospital': HomeIcon,
//       'School': HomeIcon,
//       'Park': ParkIcon,
//       'Shopping Mall': HomeIcon,
//       'Metro Station': HomeIcon,
//       'Bus Stop': HomeIcon,
//       'Restaurant': HomeIcon,
//       'Pharmacy': HomeIcon,
//       'Gated Community': SecurityIcon,
//       'Intercom': PhoneIcon,
//       'Community Hall': HomeIcon,
//       'Regular Water Supply': PoolIcon,
//       'Water Purifier': PoolIcon,
//       'Gas Pipeline': KitchenIcon,
//       'Geyser': PowerIcon,
//       'Cupboard': ChairIcon,
//       'Kids Area': ChildCareIcon,
//       'Sports': SportsSoccerIcon,
//       'Fridge': KitchenIcon
//     };
    
//     const IconComponent = amenityIconMap[amenityType] || HomeIcon;
//     return <IconComponent sx={{ color: '#666', fontSize: 20 }} />;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return `${currency}0`;
//     return `${currency}${Number(amount).toLocaleString()}`;
//   };

//   const processMedia = (mediaData) => {
//     if (!mediaData || !Array.isArray(mediaData)) return [];
    
//     return mediaData.map(item => {
//       if (typeof item === 'object' && item.image) {
//         return {
//           type: 'image',
//           data: item.image.startsWith('data:') ? item.image : `data:image/jpeg;base64,${item.image}`,
//           id: item.id || Math.random()
//         };
//       } else if (typeof item === 'object' && item.video) {
//         return {
//           type: 'video',
//           data: item.video.startsWith('data:') ? item.video : `data:video/mp4;base64,${item.video}`,
//           id: item.id || Math.random(),
//           thumbnail: item.thumbnail ? (item.thumbnail.startsWith('data:') ? item.thumbnail : `data:image/jpeg;base64,${item.thumbnail}`) : null
//         };
//       } else if (typeof item === 'string') {
//         return {
//           type: 'image',
//           data: item.startsWith('data:') ? item : `data:image/jpeg;base64,${item}`,
//           id: Math.random()
//         };
//       }
//       return null;
//     }).filter(item => item !== null);
//   };

//   const getMainImage = (mediaArray) => {
//     if (!mediaArray || mediaArray.length === 0) return null;
//     const firstImage = mediaArray.find(item => item.type === 'image');
//     if (firstImage) return firstImage.data;
//     const firstVideo = mediaArray.find(item => item.type === 'video');
//     if (firstVideo && firstVideo.thumbnail) return firstVideo.thumbnail;
//     return null;
//   };

//   const getAdditionalMedia = (mediaArray) => {
//     if (!mediaArray || mediaArray.length <= 1) return [];
//     return mediaArray.slice(1).slice(0, 3);
//   };

//   const handleMediaOpen = (media, type, index) => {
//     setSelectedMedia(media);
//     setMediaType(type);
//     setCurrentMediaIndex(index !== undefined ? index : 0);
//     setMediaDialogOpen(true);
//   };

//   const handleMediaClose = () => {
//     setMediaDialogOpen(false);
//     setSelectedMedia(null);
//   };

//   const handleNextMedia = (allMedia) => {
//     if (currentMediaIndex < allMedia.length - 1) {
//       const nextIndex = currentMediaIndex + 1;
//       const nextMedia = allMedia[nextIndex];
//       setSelectedMedia(nextMedia.data);
//       setMediaType(nextMedia.type);
//       setCurrentMediaIndex(nextIndex);
//     }
//   };

//   const handlePrevMedia = (allMedia) => {
//     if (currentMediaIndex > 0) {
//       const prevIndex = currentMediaIndex - 1;
//       const prevMedia = allMedia[prevIndex];
//       setSelectedMedia(prevMedia.data);
//       setMediaType(prevMedia.type);
//       setCurrentMediaIndex(prevIndex);
//     }
//   };

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   const handleFileUpload = (event, type) => {
//     const files = Array.from(event.target.files);
    
//     if (type === 'image' && uploadedPhotos.length + files.length > 10) {
//       setAlertDialog({
//         open: true,
//         message: 'You can only upload a maximum of 10 images',
//         severity: 'error'
//       });
//       return;
//     }
    
//     files.forEach(file => {
//       const reader = new FileReader();
      
//       reader.onload = (e) => {
//         const newMedia = {
//           id: Math.random(),
//           name: file.name,
//           size: file.size,
//           type: type,
//           preview: e.target.result,
//           file: file,
//           isNew: true
//         };
        
//         if (type === 'image') {
//           setUploadedPhotos(prev => [...prev, newMedia]);
//         } else {
//           const video = document.createElement('video');
//           video.preload = 'metadata';
//           video.onloadedmetadata = function() {
//             const canvas = document.createElement('canvas');
//             canvas.width = video.videoWidth;
//             canvas.height = video.videoHeight;
//             canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
//             const thumbnail = canvas.toDataURL();
            
//             setUploadedVideos(prev => [...prev, {
//               ...newMedia,
//               thumbnail: thumbnail
//             }]);
//           };
//           video.src = e.target.result;
//         }
//       };
      
//       reader.readAsDataURL(file);
//     });
//   };

//   const handleDeleteMedia = (id, type) => {
//     if (type === 'image') {
//       setUploadedPhotos(prev => prev.filter(item => item.id !== id));
//     } else {
//       setUploadedVideos(prev => prev.filter(item => item.id !== id));
//     }
//   };

//   const handleSaveMedia = async () => {
//     setIsUploading(true);
    
//     try {
//       const formData = new FormData();
//       formData.append('property_id', property.id);
//       formData.append('seller_id', user?.id || property.seller_id || 1);
      
//       uploadedPhotos.forEach((photo, index) => {
//         if (photo.isNew && photo.file) {
//           formData.append(`images[${index}]`, photo.file);
//           formData.append(`types[${index}]`, 'image');
//         } else if (!photo.isNew) {
//           formData.append(`existing_images[${index}]`, photo.id);
//           formData.append(`existing_types[${index}]`, 'image');
//         }
//       });
      
//       uploadedVideos.forEach((video, index) => {
//         if (video.isNew && video.file) {
//           formData.append(`videos[${index}]`, video.file);
//           formData.append(`video_types[${index}]`, 'video');
//         } else if (!video.isNew) {
//           formData.append(`existing_videos[${index}]`, video.id);
//           formData.append(`existing_video_types[${index}]`, 'video');
//         }
//       });
      
//       const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
//         method: 'POST',
//         body: formData,
//       });
      
//       const data = await response.json();
      
//       if (data.status === "SUCCESS") {
//         if (data.result && data.result.images) {
//           setProperty(prev => ({
//             ...prev,
//             images: data.result.images
//           }));
//         }
        
//         setPhotosDialogOpen(false);
//         setAlertDialog({
//           open: true,
//           message: 'Media updated successfully!',
//           severity: 'success'
//         });
        
//         setUploadedPhotos(prev => 
//           prev.map(photo => ({ ...photo, isNew: false }))
//         );
//         setUploadedVideos(prev => 
//           prev.map(video => ({ ...video, isNew: false }))
//         );
//       } else {
//         throw new Error(data.message || 'Failed to update property media');
//       }
//     } catch (error) {
//       console.error('Error saving media:', error);
//       setAlertDialog({
//         open: true,
//         message: 'Failed to update media. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchPropertyDetails = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`);
//         const data = await response.json();
        
//         if (data.status === "SUCCESS") {
//           setProperty(data.result);
//           setEditedProperty(data.result);
//         } else {
//           setError('Failed to fetch property details');
//         }
//       } catch (error) {
//         setError('Error fetching property details');
//         console.error('Error fetching property details:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     if (propertyId) {
//       fetchPropertyDetails();
//     }
//   }, [propertyId]);

//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       try {
//         if (!user?.id) return;
        
//         const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${user.id}`);
//         const data = await response.json();
        
//         if (data.status === "SUCCESS") {
//           setUserProfile({
//             full_name: data.result.full_name || '',
//             email_id: data.result.email_id || '',
//             contact_number: data.result.contact_number || '',
//             profile_image: data.result.profile_image || null
//           });
//         }
//       } catch (err) {
//         console.error('Error fetching user profile:', err);
//       }
//     };
    
//     fetchUserProfile();
//   }, [user?.id]);

//   const handleEditProperty = (section) => {
//     if (section === 'listing') {
//       setEditListingDialogOpen(true);
//     } else if (section === 'amenities') {
//       if (!shouldShowAmenities()) {
//         setAlertDialog({
//           open: true,
//           message: 'Amenities are not applicable for this property type',
//           severity: 'error'
//         });
//         return;
//       }
//       setAmenitiesDialogOpen(true);
//     } else if (section === 'photos') {
//       setPhotosDialogOpen(true);
      
//       const allMedia = processMedia(property.images || []);
      
//       const photos = allMedia.filter(item => item.type === 'image').map(item => ({
//         id: item.id,
//         name: `Property Image`,
//         preview: item.data,
//         type: 'image',
//         isNew: false
//       }));
      
//       const videos = allMedia.filter(item => item.type === 'video').map(item => ({
//         id: item.id,
//         name: `Property Video`,
//         preview: item.data,
//         thumbnail: item.thumbnail,
//         type: 'video',
//         isNew: false
//       }));
      
//       setUploadedPhotos(photos);
//       setUploadedVideos(videos);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditedProperty(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSaveChanges = async (dialogType) => {
//     try {
//       setIsSaving(true);
      
//       const payload = {
//         property_id: editedProperty.id,
//         seller_id: user?.id || editedProperty.seller_id || 1,
//       };
      
//       if (dialogType === 'listing') {
//         const numericFields = [
//           'asking_price', 'property_size', 'bhk', 'bathrooms',
//           'total_floors', 'select_floor', 'age_of_property',
//           'monthly_rent', 'carpet_area', 'built_up_area', 'length', 'width'
//         ];
        
//         const fieldsToCheck = [
//           'property_name', 'location', 'area_name', 'asking_price', 'currency',
//           'property_size', 'property_size_units', 'bhk', 'bathrooms',
//           'description', 'total_floors', 'select_floor', 'furnish_type', 'negotiable',
//           'age_of_property', 'construction_status', 'full_address', 'youtube_link',
//           'carpet_area', 'carpet_area_units', 'built_up_area', 'built_up_area_units',
//           'monthly_rent', 'security_deposit', 'available_from', 'length', 'width',
//           'ownership', 'commercial_catgory', 'commercial_asset_type', 'hub', 'content'
//         ];
        
//         fieldsToCheck.forEach(field => {
//           if (editedProperty[field] !== undefined && editedProperty[field] !== null && editedProperty[field] !== '') {
//             if (numericFields.includes(field)) {
//               const numValue = Number(editedProperty[field]);
//               if (!isNaN(numValue)) {
//                 payload[field] = numValue;
//               }
//             } else if (field === 'negotiable') {
//               payload[field] = editedProperty[field] === 'true' || editedProperty[field] === true;
//             } else {
//               payload[field] = editedProperty[field];
//             }
//           }
//         });
//       } else if (dialogType === 'amenities') {
//         if (!shouldShowAmenities()) {
//           setAlertDialog({
//             open: true,
//             message: 'Amenities are not applicable for this property type',
//             severity: 'error'
//           });
//           setIsSaving(false);
//           return;
//         }
//         payload.society_aminities = editedProperty.society_aminities || '';
//         payload.furnish_facilities = editedProperty.furnish_facilities || '';
//         payload.other_facilities = editedProperty.other_facilities || '';
//         payload.facilities_distance = editedProperty.facilities_distance || '';
//       }
      
//       console.log('Saving payload:', payload);
      
//       const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(payload)
//       });
      
//       const data = await response.json();
      
//       if (data.status === "SUCCESS") {
//         setProperty(prev => ({
//           ...prev,
//           ...editedProperty
//         }));
        
//         const refreshResponse = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}&timestamp=${new Date().getTime()}`);
//         const refreshData = await refreshResponse.json();
        
//         if (refreshData.status === "SUCCESS") {
//           setProperty(refreshData.result);
//           setEditedProperty(refreshData.result);
//         }
        
//         if (dialogType === 'listing') {
//           setEditListingDialogOpen(false);
//         } else if (dialogType === 'amenities') {
//           setAmenitiesDialogOpen(false);
//         }
        
//         setAlertDialog({
//           open: true,
//           message: 'Property updated successfully!',
//           severity: 'success'
//         });
//       } else {
//         throw new Error(data.message || 'Failed to update property');
//       }
//     } catch (error) {
//       console.error('Error updating property:', error);
//       setAlertDialog({
//         open: true,
//         message: error.message || 'Failed to update property. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const handleAlertClose = () => {
//     setAlertDialog(prev => ({
//       ...prev,
//       open: false
//     }));
//   };

//   if (loading) return <Loader />;

//   if (error) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           {error}
//         </Typography>
//         <Button variant="contained" onClick={() => navigate('/sell-properties')}>
//           Back to Properties
//         </Button>
//       </Box>
//     );
//   }

//   if (!property) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
//         <Typography variant="h6" gutterBottom>
//           Property not found
//         </Typography>
//         <Button variant="contained" onClick={() => navigate('/sell-properties')}>
//           Back to Properties
//         </Button>
//       </Box>
//     );
//   }

//   const allMedia = processMedia(property.images);
//   const mainImageSrc = getMainImage(allMedia);
//   const additionalMedia = getAdditionalMedia(allMedia);
//   const remainingMediaCount = allMedia.length - 4 > 0 ? allMedia.length - 4 : 0;

//   const calculateBuiltYear = () => {
//     if (!hasValue(property.age_of_property)) return null;
//     const age = Number(property.age_of_property);
//     if (isNaN(age) || age < 0 || age > 100) return null;
//     return new Date().getFullYear() - age;
//   };

//   const propertyData = {
//     id: property.id,
//     price: property.category === 'rent' && hasValue(property.monthly_rent)
//       ? formatCurrency(property.monthly_rent, property.currency) + '/month'
//       : formatCurrency(property.asking_price, property.currency),
//     title: property.property_name,
//     location: `${property.area_name}, ${property.location}`,
//     date: formatDate(property.createdAt),
//     views: '0 Views',
//     beds: property.bhk || 0,
//     baths: property.bathrooms || 0,
//     area: `${property.property_size} ${property.property_size_units}`,
//     mainImage: mainImageSrc,
//     additionalMedia: additionalMedia,
//     description: property.description || 'This property is currently under verification. Update the description to provide more details about your property.',
//     propertyType: `${property.property_type} - ${property.asset_type}`,
//     propertyID: `#PD${property.id.toString().padStart(6, '0')}`,
//     builtYear: calculateBuiltYear(),
//         status: property.status,
//     amenities: property.society_aminities ? property.society_aminities.split(', ') : [],
//     furnishFacilities: property.furnish_facilities ? property.furnish_facilities.split(', ') : [],
//     otherFacilities: property.other_facilities ? property.other_facilities.split(', ') : [],
//     seller: property.seller || { full_name: 'Owner', email_id: 'N/A', contact_number: 'N/A' }
//   };

//   const allAmenities = [
//     ...propertyData.amenities,
//     ...propertyData.furnishFacilities,
//     ...propertyData.otherFacilities
//   ];

//   return (
//     <>
//       <Card sx={{
//         width: '100%',
//         maxWidth: '100%',
//         borderRadius: 2,
//         boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//         overflow: 'hidden',
//         mb: 3,
//         marginTop: { xs: '30px', md: '5px' },
//       }}>
//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, height: { xs: 'auto', md: '300px' } }}>
//           <Box sx={{
//             width: { xs: '100%', md: '70%' },
//             height: { xs: '200px', md: '100%' },
//             position: 'relative',
//             cursor: propertyData.mainImage ? 'pointer' : 'default',
//             bgcolor: '#f0f0f0',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center'
//           }} onClick={() => propertyData.mainImage && handleMediaOpen(propertyData.mainImage, 'image', 0)}>
            
//             {propertyData.mainImage ? (
//               <CardMedia
//                 component="img"
//                 sx={{
//                   height: '100%',
//                   width: '100%',
//                   objectFit: 'cover',
//                 }}
//                 image={propertyData.mainImage}
//                 alt={propertyData.title}
//               />
//             ) : (
//               <Typography variant="body1" color="text.secondary">
//                 No Media
//               </Typography>
//             )}
//             {allMedia.length > 0 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: 10,
//                   right: 10,
//                   bgcolor: 'rgba(0,0,0,0.6)',
//                   color: 'white',
//                   px: 1,
//                   py: 0.5,
//                   borderRadius: 1,
//                   fontSize: '0.75rem'
//                 }}
//               >
//                 1/{allMedia.length}
//               </Box>
//             )}
//             <Button
//               variant="contained"
//               size="small"
//               sx={{
//                 position: 'absolute',
//                 top: 10,
//                 right: 10,
//                 bgcolor: 'rgba(0,0,0,0.7)',
//                 color: 'white',
//                 borderRadius: 1,
//                 textTransform: 'none',
//                 '&:hover': {
//                   bgcolor: 'rgba(0,0,0,0.8)',
//                 }
//               }}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleEditProperty('photos');
//               }}
//             >
//               Manage Photos
//             </Button>
//             {propertyData.status && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: 10,
//                   left: 10,
//                   backgroundColor: propertyData.status === 'active' ? '#10b981' :
//                     propertyData.status === 'under_verification' ? '#f59e0b' : 'rgba(0,0,0,0.7)',
//                   color: 'white',
//                   padding: '4px 10px',
//                   borderRadius: '4px',
//                   fontSize: '12px',
//                   fontWeight: 500,
//                   textTransform: 'capitalize'
//                 }}
//               >
//                 {propertyData.status.replace(/\_/g, ' ')}
//               </Box>
//             )}
//           </Box>
//           <Box sx={{
//             width: { xs: '100%', md: '30%' },
//             height: { xs: 'auto', md: '100%' },
//             display: 'flex',
//             flexDirection: { xs: 'row', md: 'column' },
//           }}>
//             {propertyData.additionalMedia.length > 0 ? (
//               propertyData.additionalMedia.map((media, index) => (
//                 <Box
//                   key={media.id || index}
//                   sx={{
//                     flex: 1,
//                     overflow: 'hidden',
//                     borderLeft: { xs: 'none', md: '2px solid white' },
//                     borderBottom: {
//                       xs: 'none',
//                       md: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none'
//                     },
//                     borderRight: {
//                       xs: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none',
//                       md: 'none'
//                     },
//                     height: { xs: '100px', md: 'auto' },
//                     position: 'relative',
//                     cursor: 'pointer'
//                   }}
//                   onClick={() => handleMediaOpen(media.data, media.type, index + 1)}
//                 >
//                   {media.type === 'video' && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         color: 'white',
//                         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                         borderRadius: '50%',
//                         width: 40,
//                         height: 40,
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         zIndex: 2
//                       }}
//                     >
//                       <PlayArrowIcon />
//                     </Box>
//                   )}
//                   <CardMedia
//                     component="img"
//                     image={media.type === 'video' && media.thumbnail ? media.thumbnail : media.data}
//                     alt={media.type === 'video' ? 'Property video' : `Property view ${index + 2}`}
//                     sx={{
//                       height: '100%',
//                       width: '100%',
//                       objectFit: 'cover',
//                       filter: media.type === 'video' ? 'brightness(0.8)' : 'none'
//                     }}
//                   />
//                   {media.type === 'video' && (
//                     <Chip
//                       label="Video"
//                       size="small"
//                       sx={{
//                         position: 'absolute',
//                         top: 5,
//                         right: 5,
//                         backgroundColor: 'rgba(0, 0, 0, 0.7)',
//                         color: 'white',
//                         fontSize: '10px',
//                         height: '20px'
//                       }}
//                     />
//                   )}
//                   {index === 2 && remainingMediaCount > 0 && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         bottom: 0,
//                         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         color: 'white',
//                         fontWeight: 'bold',
//                         fontSize: '1.5rem'
//                       }}
//                     >
//                       +{remainingMediaCount}
//                     </Box>
//                   )}
//                 </Box>
//               ))
//             ) : (
//               Array.from({ length: 3 }).map((_, index) => (
//                 <Box
//                   key={`empty-${index}`}
//                   sx={{
//                     flex: 1,
//                     backgroundColor: '#f0f0f0',
//                     borderLeft: { xs: 'none', md: '2px solid white' },
//                     borderBottom: {
//                       xs: 'none',
//                       md: index !== 2 ? '2px solid white' : 'none'
//                     },
//                     borderRight: {
//                       xs: index !== 2 ? '2px solid white' : 'none',
//                       md: 'none'
//                     },
//                     height: { xs: '100px', md: 'auto' },
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}
//                 >
//                   <Typography variant="caption" color="text.secondary">
//                     No Media
//                   </Typography>
//                 </Box>
//               ))
//             )}
//           </Box>
//         </Box>
//         <CardContent sx={{ p: 2 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//             <Typography variant="h5" component="div" sx={{ fontWeight: '600', color: '#3366CC', fontFamily: 'Outfit' }}>
//               {propertyData.price}
//             </Typography>
//             <Button
//               variant="contained"
//               onClick={() => handleEditProperty('listing')}
//               sx={{
//                 bgcolor: '#4285F4',
//                 borderRadius: 2,
//                 textTransform: 'none',
//                 px: 2,
//                 py: 0.5,
//                 fontSize: '0.875rem',
//                 fontFamily: 'Outfit'
//               }}
//             >
//               Edit Listing
//             </Button>
//           </Box>
//           <Typography variant="h6" component="div" sx={{ fontWeight: '500', mb: 1, fontFamily: 'Outfit' }}>
//             {propertyData.title}
//           </Typography>
//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//             <LocationOnIcon sx={{ color: 'text.secondary', fontSize: 18, mr: 0.5, fontWeight: '400' }} />
//             <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//               {propertyData.location}
//             </Typography>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
//               <CalendarTodayIcon sx={{ color: 'text.secondary', fontSize: 18, mr: 0.5, fontWeight: '400' }} />
//               <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                 {propertyData.date}
//               </Typography>
//             </Box>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <VisibilityIcon sx={{ color: 'text.secondary', fontSize: 18, mr: 0.5, fontWeight: '400' }} />
//               <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                 {propertyData.views}
//               </Typography>
//             </Box>
//           </Box>
//           {/* ✅ Only show BHK/Bathrooms/Area if they have values */}
//           <Grid container spacing={2}>
//             {hasValue(property.bhk) && (
//               <Grid item xs={4}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <HotelIcon sx={{ color: 'text.secondary', fontSize: 20, mr: 1, fontWeight: '400' }} />
//                   <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                     {propertyData.beds} Beds
//                   </Typography>
//                 </Box>
//               </Grid>
//             )}
//             {hasValue(property.bathrooms) && (
//               <Grid item xs={4}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <BathtubIcon sx={{ color: 'text.secondary', fontSize: 20, mr: 1, fontWeight: '400' }} />
//                   <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                     {propertyData.baths} Baths
//                   </Typography>
//                 </Box>
//               </Grid>
//             )}
//             {hasValue(property.property_size) && (
//               <Grid item xs={4}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <SquareFootIcon sx={{ color: 'text.secondary', fontSize: 20, mr: 1, fontWeight: '400' }} />
//                   <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                     {propertyData.area}
//                   </Typography>
//                 </Box>
//               </Grid>
//             )}
//           </Grid>
//           {/* ✅ Property Description - Show if it has value */}
//           {hasValue(property.description) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{ fontWeight: '500', mb: 2, fontFamily: 'Outfit' }}>
//                 Property Description
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 3, fontFamily: 'Outfit' }}>
//                 {propertyData.description}
//               </Typography>
//             </Box>
//           )}
//           {/* ✅ Content Section - Show if it has value (for commercial plots) */}
//           {hasValue(property.content) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{ fontWeight: '500', mb: 2, fontFamily: 'Outfit' }}>
//                 Additional Content
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 3, fontFamily: 'Outfit' }}>
//                 {property.content}
//               </Typography>
//             </Box>
//           )}
//           {/* ✅ Complete Address - Show if it has value */}
//           {hasValue(property.full_address) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{ fontWeight: '500', mb: 2, fontFamily: 'Outfit' }}>
//                 Complete Address
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 3, fontFamily: 'Outfit' }}>
//                 {property.full_address}
//               </Typography>
//             </Box>
//           )}
//           {/* ✅ YouTube Link - Show if it has value */}
//           {hasValue(property.youtube_link) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{ fontWeight: '500', mb: 2, fontFamily: 'Outfit' }}>
//                 Property Video
//               </Typography>
//               <a href={property.youtube_link} target="_blank" rel="noopener noreferrer" style={{ color: '#4285F4', textDecoration: 'none', fontFamily: 'Outfit' }}>
//                 Watch on YouTube
//               </a>
//             </Box>
//           )}
//           {/* ✅ Carpet Area & Built-up Area - Only for Apartments */}
//           {property.asset_type === 'Apartment' && (hasValue(property.carpet_area) || hasValue(property.built_up_area)) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{ fontWeight: '500', mb: 2, fontFamily: 'Outfit' }}>
//                 Area Details
//               </Typography>
//               <Grid container spacing={2}>
//                 {hasValue(property.carpet_area) && (
//                   <Grid item xs={12} md={6}>
//                     <Box sx={{
//                       p: 2,
//                       bgcolor: '#f8f9fa',
//                       borderRadius: 2,
//                       border: '1px solid #e0e0e0'
//                     }}>
//                       <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontFamily: 'Outfit' }}>
//                         Carpet Area
//                       </Typography>
//                       <Typography variant="h6" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                         {property.carpet_area} {property.carpet_area_units}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 )}
//                 {hasValue(property.built_up_area) && (
//                   <Grid item xs={12} md={6}>
//                     <Box sx={{
//                       p: 2,
//                       bgcolor: '#f8f9fa',
//                       borderRadius: 2,
//                       border: '1px solid #e0e0e0'
//                     }}>
//                       <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontFamily: 'Outfit' }}>
//                         Built-up Area
//                       </Typography>
//                       <Typography variant="h6" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                         {property.built_up_area} {property.built_up_area_units}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//           {/* ✅ Features & Amenities Section - Only show for applicable property types */}
//           {shouldShowAmenities() && allAmenities.length > 0 && (
//             <Box sx={{ mt: 3 }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                 <Typography variant="h6" component="div" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                   Features & Amenities
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   onClick={() => handleEditProperty('amenities')}
//                   sx={{
//                     bgcolor: '#4285F4',
//                     borderRadius: 2,
//                     textTransform: 'none',
//                     px: 2,
//                     py: 0.5,
//                     fontSize: '0.875rem',
//                     fontFamily: 'Outfit'
//                   }}
//                 >
//                   Manage Amenities
//                 </Button>
//               </Box>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   {allAmenities.slice(0, 8).map((amenity, index) => (
//                     <Box
//                       key={index}
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         mb: 2
//                       }}
//                     >
//                       <Box component="span" sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         border: '1px solid #e0e0e0',
//                         borderRadius: '4px',
//                         p: 0.5,
//                         mr: 1.5,
//                         width: 32,
//                         height: 32
//                       }}>
//                         {getAmenityIcon(amenity)}
//                       </Box>
//                       <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>{amenity}</Typography>
//                     </Box>
//                   ))}
//                 </Grid>
//                 {allAmenities.length > 8 && (
//                   <Grid item xs={12} md={6}>
//                     {allAmenities.slice(8).map((amenity, index) => (
//                       <Box
//                         key={index}
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           mb: 2
//                         }}
//                       >
//                         <Box component="span" sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           border: '1px solid #e0e0e0',
//                           borderRadius: '4px',
//                           p: 0.5,
//                           mr: 1.5,
//                           width: 32,
//                           height: 32
//                         }}>
//                           {getAmenityIcon(amenity)}
//                         </Box>
//                         <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>{amenity}</Typography>
//                       </Box>
//                     ))}
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//           {/* ✅ Additional Details Section - Show only fields with values */}
//           <Box sx={{ mt: 4 }}>
//             <Typography variant="h6" component="div" sx={{ fontWeight: '500', mb: 2, fontFamily: 'Outfit' }}>
//               Additional details
//             </Typography>
//             <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//               <Box sx={{ display: 'flex', py: 1.5 }}>
//                 <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                   Property type
//                 </Typography>
//                 <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                   {propertyData.propertyType}
//                 </Typography>
//               </Box>
//               <Box sx={{ display: 'flex', py: 1.5 }}>
//                 <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                   Property ID
//                 </Typography>
//                 <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                   {propertyData.propertyID}
//                 </Typography>
//               </Box>
//               {hasValue(property.negotiable) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Price Negotiable
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit', textTransform: 'capitalize' }}>
//                     {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.total_floors) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Total Floors
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {property.total_floors}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.select_floor) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Floor Number
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {property.select_floor}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.furnish_type) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Furnishing
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit', textTransform: 'capitalize' }}>
//                     {property.furnish_type.replace(/-/g, ' ')}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.construction_status) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Construction Status
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit', textTransform: 'capitalize' }}>
//                     {property.construction_status}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.monthly_rent) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Monthly Rent
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {formatCurrency(property.monthly_rent, property.currency)}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.security_deposit) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Security Deposit
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {property.security_deposit}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.available_from) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Available From
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {formatDate(property.available_from)}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.length) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Length
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {property.length} {property.property_size_units}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.width) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Width
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {property.width} {property.property_size_units}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.ownership) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Ownership
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit', textTransform: 'capitalize' }}>
//                     {property.ownership}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.hub) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Hub
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                     {property.hub}
//                   </Typography>
//                 </Box>
//               )}
//               {hasValue(property.commercial_catgory) && (
//                 <Box sx={{ display: 'flex', py: 1.5 }}>
//                   <Typography variant="body2" color="text.secondary" sx={{ width: '150px', fontFamily: 'Outfit' }}>
//                     Category
//                   </Typography>
//                   <Typography variant="body2" sx={{ fontWeight: '500', fontFamily: 'Outfit', textTransform: 'capitalize' }}>
//                     {property.commercial_catgory}
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           </Box>
//           {/* Contact Information Section */}
//           <Box sx={{ mt: 4 }}>
//             <Box sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               mb: 3
//             }}>
//               <Typography variant="h6" component="div" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                 Contact Information
//               </Typography>
//             </Box>
//             <Box sx={{
//               display: 'flex',
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Box
//                 component="div"
//                 sx={{
//                   width: 48,
//                   height: 48,
//                   borderRadius: '50%',
//                   bgcolor: '#f0f0f0',
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   mr: 2,
//                   overflow: 'hidden'
//                 }}
//               >
//                 <img
//                   src={userProfile.profile_image || "https://propertydealstalk.com/api/portraits/men/32.jpg"}
//                   alt="Profile"
//                   style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="subtitle1" sx={{ fontWeight: '500', fontFamily: 'Outfit', mb: 1 }}>
//                   {userProfile.full_name || propertyData.seller.full_name}
//                 </Typography>
//                 <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                     <PhoneIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                                         <Typography variant="body2" sx={{ fontFamily: 'Outfit', color: 'blue' }}>
//                       {userProfile.contact_number || propertyData.seller.contact_number}
//                     </Typography>
//                   </Box>
//                   <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                     <EmailIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
//                     <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>
//                       {userProfile.email_id || propertyData.seller.email_id}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Media Dialog with Navigation */}
//       <Dialog
//         open={mediaDialogOpen}
//         onClose={handleMediaClose}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogContent sx={{ position: 'relative', p: 0, backgroundColor: 'black' }}>
//           <IconButton
//             aria-label="close"
//             onClick={handleMediaClose}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: 'white',
//               zIndex: 10,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
//               }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <IconButton
//             aria-label="previous media"
//             onClick={() => handlePrevMedia(allMedia)}
//             disabled={currentMediaIndex === 0}
//             sx={{
//               position: 'absolute',
//               left: 8,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               color: 'white',
//               zIndex: 10,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
//               },
//               opacity: currentMediaIndex === 0 ? 0.5 : 1,
//               visibility: currentMediaIndex === 0 ? 'hidden' : 'visible',
//             }}
//           >
//             <ChevronLeftIcon fontSize="large" />
//           </IconButton>
//           <IconButton
//             aria-label="next media"
//             onClick={() => handleNextMedia(allMedia)}
//             disabled={currentMediaIndex === allMedia.length - 1}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               color: 'white',
//               zIndex: 10,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
//               },
//               opacity: currentMediaIndex === allMedia.length - 1 ? 0.5 : 1,
//               visibility: currentMediaIndex === allMedia.length - 1 ? 'hidden' : 'visible',
//             }}
//           >
//             <ChevronRightIcon fontSize="large" />
//           </IconButton>
//           <Box
//             sx={{
//               position: 'absolute',
//               bottom: 16,
//               left: '50%',
//               transform: 'translateX(-50%)',
//               color: 'white',
//               zIndex: 10,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               padding: '4px 12px',
//               borderRadius: 16,
//               fontSize: '14px',
//             }}
//           >
//             {currentMediaIndex + 1} / {allMedia.length}
//           </Box>
//           {mediaType === 'image' ? (
//             <img
//               src={selectedMedia}
//               alt="Property"
//               style={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
//             />
//           ) : (
//             <video
//               controls
//               autoPlay
//               style={{ width: '100%', height: 'auto', maxHeight: '80vh' }}
//             >
//               <source src={selectedMedia} type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//           )}
//         </DialogContent>
//       </Dialog>

//       {/* Photos Management Dialog */}
//       <Dialog
//         open={photosDialogOpen}
//         onClose={() => setPhotosDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2
//         }}>
//           Manage Property Media
//           <IconButton onClick={() => setPhotosDialogOpen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3 }}>
//           <Tabs value={tabValue} onChange={handleTabChange} centered sx={{ mb: 3 }}>
//             <Tab label="Photos" />
//             <Tab label="Videos" />
//           </Tabs>
//           {tabValue === 0 ? (
//             <Box>
//               <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
//                 <Button
//                   variant="contained"
//                   component="label"
//                   startIcon={<AddPhotoAlternateIcon />}
//                   sx={{
//                     bgcolor: '#4285F4',
//                     borderRadius: 2,
//                     textTransform: 'none',
//                     px: 3,
//                     py: 1,
//                     fontSize: '0.875rem'
//                   }}
//                   disabled={uploadedPhotos.length >= 10}
//                 >
//                   Add Photos
//                   <input
//                     type="file"
//                     hidden
//                     accept="image/*"
//                     multiple
//                     onChange={(e) => handleFileUpload(e, 'image')}
//                   />
//                 </Button>
//               </Box>
//               {uploadedPhotos.length >= 10 && (
//                 <Typography
//                   variant="caption"
//                   color="error"
//                   align="center"
//                   sx={{ display: 'block', mb: 2 }}
//                 >
//                   Maximum limit of 10 images reached
//                 </Typography>
//               )}
//               <Grid container spacing={2}>
//                 {uploadedPhotos.map((photo) => (
//                   <Grid item xs={12} sm={6} md={4} key={photo.id}>
//                     <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', height: 180 }}>
//                       <img
//                         src={photo.preview}
//                         alt={photo.name}
//                         style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                       />
//                       <IconButton
//                         sx={{
//                           position: 'absolute',
//                           top: 8,
//                           right: 8,
//                           bgcolor: 'rgba(0,0,0,0.5)',
//                           color: 'white',
//                           '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//                         }}
//                         onClick={() => handleDeleteMedia(photo.id, 'image')}
//                       >
//                         <DeleteIcon />
//                       </IconButton>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//               {uploadedPhotos.length === 0 && (
//                 <Box sx={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   bgcolor: '#f5f5f5',
//                   borderRadius: 2,
//                   p: 4,
//                   mt: 2
//                 }}>
//                   <CloudUploadIcon sx={{ fontSize: 60, color: '#bdbdbd', mb: 2 }} />
//                   <Typography variant="body1" color="text.secondary" align="center">
//                     No photos uploaded yet. Click "Add Photos" to upload property images.
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           ) : (
//             <Box>
//               <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
//                 <Button
//                   variant="contained"
//                   component="label"
//                   startIcon={<MovieIcon />}
//                   sx={{
//                     bgcolor: '#4285F4',
//                     borderRadius: 2,
//                     textTransform: 'none',
//                     px: 3,
//                     py: 1,
//                     fontSize: '0.875rem'
//                   }}
//                 >
//                   Add Videos
//                   <input
//                     type="file"
//                     hidden
//                     accept="video/*"
//                     multiple
//                     onChange={(e) => handleFileUpload(e, 'video')}
//                   />
//                 </Button>
//               </Box>
//               <Grid container spacing={2}>
//                 {uploadedVideos.map((video) => (
//                   <Grid item xs={12} sm={6} md={4} key={video.id}>
//                     <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', height: 180 }}>
//                       <Box sx={{
//                         width: '100%',
//                         height: '100%',
//                         bgcolor: '#000',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         position: 'relative'
//                       }}>
//                         {video.thumbnail ? (
//                           <img
//                             src={video.thumbnail}
//                             alt={video.name}
//                             style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.7 }}
//                           />
//                         ) : (
//                           <MovieIcon sx={{ fontSize: 40, color: '#fff' }} />
//                         )}
//                         <PlayArrowIcon sx={{
//                           position: 'absolute',
//                           color: 'white',
//                           fontSize: 40,
//                           opacity: 0.8
//                         }} />
//                       </Box>
//                       <IconButton
//                         sx={{
//                           position: 'absolute',
//                           top: 8,
//                           right: 8,
//                           bgcolor: 'rgba(0,0,0,0.5)',
//                           color: 'white',
//                           '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//                         }}
//                         onClick={() => handleDeleteMedia(video.id, 'video')}
//                       >
//                         <DeleteIcon />
//                       </IconButton>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//               {uploadedVideos.length === 0 && (
//                 <Box sx={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   bgcolor: '#f5f5f5',
//                   borderRadius: 2,
//                   p: 4,
//                   mt: 2
//                 }}>
//                   <MovieIcon sx={{ fontSize: 60, color: '#bdbdbd', mb: 2 }} />
//                   <Typography variant="body1" color="text.secondary" align="center">
//                     No videos uploaded yet. Click "Add Videos" to upload property videos.
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
//           <Button
//             onClick={() => setPhotosDialogOpen(false)}
//             variant="outlined"
//             sx={{ borderRadius: 2, textTransform: 'none', px: 3 }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSaveMedia}
//             variant="contained"
//             color="primary"
//             disabled={isUploading}
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               bgcolor: '#4285F4',
//               '&:hover': {
//                 bgcolor: '#3367d6',
//               }
//             }}
//           >
//             {isUploading ? <CircularProgress size={24} /> : 'Save Media'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Listing Dialog */}
//       <Dialog
//         open={editListingDialogOpen}
//         onClose={() => setEditListingDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2
//         }}>
//           Edit Property Listing
//           <IconButton onClick={() => setEditListingDialogOpen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3 }}>
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
//             {/* Basic Details Section */}
//             <Paper elevation={0} sx={{ p: 2 }}>
//               <Box sx={{
//                 borderLeft: '4px solid #4285F4',
//                 pl: 2,
//                 mb: 3,
//                 py: 0.5,
//                 backgroundColor: '#f5f8ff',
//                 width: '100%',
//                 textAlign: 'left'
//               }}>
//                 <Typography variant="subtitle1" sx={{
//                   fontWeight: 600,
//                   fontFamily: 'Outfit',
//                   color: '#333'
//                 }}>
//                   Basic Details
//                 </Typography>
//               </Box>
//               <Grid container spacing={2}>
//                 {/* ✅ Property Name - Always show */}
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Property Name"
//                     name="property_name"
//                     value={editedProperty?.property_name || ''}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                     sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}
//                     placeholder="Enter property name"
//                   />
//                 </Grid>
//                 {/* ✅ Location - Always show */}
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Location"
//                     name="location"
//                     value={editedProperty?.location || ''}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                     sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}
//                     placeholder="Enter location (city)"
//                   />
//                 </Grid>
//                 {/* ✅ Area Name - Always show */}
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Area Name"
//                     name="area_name"
//                     value={editedProperty?.area_name || ''}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                     sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}
//                     placeholder="Enter area or locality name"
//                   />
//                 </Grid>
//                 {/* ✅ Property Type - DISABLED (Cannot be changed) */}
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Property Type"
//                     value={editedProperty?.property_type || ''}
//                     variant="outlined"
//                     disabled
//                     sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px',
//                         backgroundColor: '#f5f5f5'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}
//                   />
//                 </Grid>
//                 {/* ✅ Asset Type - DISABLED (Cannot be changed) */}
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Asset Type"
//                     value={editedProperty?.asset_type || ''}
//                     variant="outlined"
//                     disabled
//                     sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px',
//                         backgroundColor: '#f5f5f5'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}
//                   />
//                 </Grid>
//                 {/* ✅ Category - DISABLED (Cannot be changed) */}
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Category"
//                     value={editedProperty?.category || ''}
//                     variant="outlined"
//                     disabled
//                     sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px',
//                         backgroundColor: '#f5f5f5',
//                         textTransform: 'capitalize'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}
//                   />
//                 </Grid>
//                 {/* ✅ Furnish Type - Show if has value */}
//                 {hasValue(property.furnish_type) && (
//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}>
//                       <InputLabel>Furnish Type</InputLabel>
//                       <Select
//                         name="furnish_type"
//                         value={editedProperty?.furnish_type || ''}
//                         onChange={handleInputChange}
//                         label="Furnish Type"
//                       >
//                         <MenuItem value="fully">Fully Furnished</MenuItem>
//                         <MenuItem value="semi">Semi Furnished</MenuItem>
//                         <MenuItem value="unfurnished">Unfurnished</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 )}
//                 {/* ✅ Full Address - Show if has value */}
//                 {hasValue(property.full_address) && (
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Complete Address"
//                       name="full_address"
//                       value={editedProperty?.full_address || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       multiline
//                       rows={2}
//                       sx={{ mb: 2 }}
//                       placeholder="Enter complete address with landmark"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ YouTube Link - Show if has value */}
//                 {hasValue(property.youtube_link) && (
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="YouTube Link"
//                       name="youtube_link"
//                       value={editedProperty?.youtube_link || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Enter YouTube video link"
//                     />
//                   </Grid>
//                 )}
//               </Grid>
//             </Paper>

//             {/* Price Details Section */}
//             <Paper elevation={0} sx={{ p: 2 }}>
//               <Box sx={{
//                 borderLeft: '4px solid #4285F4',
//                 pl: 2,
//                 mb: 3,
//                 py: 0.5,
//                 backgroundColor: '#f5f8ff',
//                 width: '100%',
//                 textAlign: 'left'
//               }}>
//                 <Typography variant="subtitle1" sx={{
//                   fontWeight: 600,
//                   fontFamily: 'Outfit',
//                   color: '#333'
//                 }}>
//                   Price Details
//                 </Typography>
//               </Box>
//               <Grid container spacing={2}>
//                 {/* ✅ Asking Price - Show if has value OR if category is 'sale' */}
//                 {(hasValue(property.asking_price) || property.category === 'sale') && (
//                   <>
//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         fullWidth
//                         label={property.category === 'rent' ? "Asking Price (Optional)" : "Asking Price"}
//                         name="asking_price"
//                         type="number"
//                         value={editedProperty?.asking_price || ''}
//                         onChange={handleInputChange}
//                         variant="outlined"
//                         sx={{
//                           mb: 2,
//                           '& .MuiInputBase-root': {
//                             height: '56px'
//                           },
//                           '& .MuiInputLabel-root': {
//                             lineHeight: '1.2'
//                           }
//                         }}
//                         placeholder="Enter price amount"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               {editedProperty?.currency || '₹'}
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                       <FormControl fullWidth sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}>
//                         <InputLabel>Currency</InputLabel>
//                         <Select
//                           name="currency"
//                           value={editedProperty?.currency || '₹'}
//                           onChange={handleInputChange}
//                           label="Currency"
//                         >
//                           <MenuItem value="₹">₹ (INR)</MenuItem>
//                           <MenuItem value="$">$ (USD)</MenuItem>
//                           <MenuItem value="€">€ (EUR)</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={editedProperty?.negotiable === 'true' || editedProperty?.negotiable === true}
//                             onChange={(e) => setEditedProperty(prev => ({
//                               ...prev,
//                               negotiable: e.target.checked ? 'true' : 'false'
//                             }))}
//                             name="negotiable"
//                             sx={{ color: '#4285F4' }}
//                           />
//                         }
//                         label="Price is Negotiable"
//                         sx={{ fontFamily: 'Outfit' }}
//                       />
//                     </Grid>
//                   </>
//                 )}
//                 {/* ✅ Monthly Rent - Show if has value */}
//                 {hasValue(property.monthly_rent) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Monthly Rent"
//                       name="monthly_rent"
//                       type="number"
//                       value={editedProperty?.monthly_rent || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Enter monthly rent"
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             {editedProperty?.currency || '₹'}
//                           </InputAdornment>
//                         ),
//                       }}
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Security Deposit - Show if has value */}
//                 {hasValue(property.security_deposit) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Security Deposit"
//                       name="security_deposit"
//                       value={editedProperty?.security_deposit || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="e.g., 1month, 2months, or amount"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Available From - Show if has value */}
//                 {hasValue(property.available_from) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Available From"
//                       name="available_from"
//                       type="date"
//                       value={editedProperty?.available_from || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       InputLabelProps={{
//                         shrink: true,
//                       }}
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                     />
//                   </Grid>
//                 )}
//               </Grid>
//             </Paper>

//             {/* Property Specifications Section */}
//             <Paper elevation={0} sx={{ p: 2 }}>
//               <Box sx={{
//                 borderLeft: '4px solid #4285F4',
//                 pl: 2,
//                 mb: 3,
//                 py: 0.5,
//                 backgroundColor: '#f5f8ff',
//                 width: '100%',
//                 textAlign: 'left'
//               }}>
//                 <Typography variant="subtitle1" sx={{
//                   fontWeight: 600,
//                   fontFamily: 'Outfit',
//                   color: '#333'
//                 }}>
//                   Property Specifications
//                 </Typography>
//               </Box>
//               <Grid container spacing={2}>
//                 {/* ✅ BHK - Show if has value */}
//                 {hasValue(property.bhk) && (
//                   <Grid item xs={12} md={4}>
//                     <TextField
//                       fullWidth
//                       label="BHK"
//                       name="bhk"
//                       type="number"
//                       value={editedProperty?.bhk || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="No. of bedrooms"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Bathrooms - Show if has value */}
//                 {hasValue(property.bathrooms) && (
//                   <Grid item xs={12} md={4}>
//                     <TextField
//                       fullWidth
//                       label="Bathrooms"
//                       name="bathrooms"
//                       type="number"
//                       value={editedProperty?.bathrooms || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="No. of bathrooms"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Property Size - Show if has value */}
//                 {hasValue(property.property_size) && (
//                   <>
//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         fullWidth
//                         label="Property Size"
//                         name="property_size"
//                         type="number"
//                         value={editedProperty?.property_size || ''}
//                         onChange={handleInputChange}
//                         variant="outlined"
//                         sx={{
//                           mb: 2,
//                           '& .MuiInputBase-root': {
//                             height: '56px'
//                           },
//                           '& .MuiInputLabel-root': {
//                             lineHeight: '1.2'
//                           }
//                         }}
//                         placeholder="Enter property size"
//                       />
//                     </Grid>
                    
//                     <Grid item xs={12} md={6}>
//                       <FormControl fullWidth sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}>
//                         <InputLabel>Unit</InputLabel>
//                         <Select
//                           name="property_size_units"
//                           value={editedProperty?.property_size_units || ''}
//                           onChange={handleInputChange}
//                           label="Unit"
//                         >
//                           <MenuItem value="sq.ft">Square Feet</MenuItem>
//                           <MenuItem value="sq.m">Square Meters</MenuItem>
//                           <MenuItem value="acres">Acres</MenuItem>
//                           <MenuItem value="hectares">Hectares</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </>
//                 )}
//                                 {/* ✅ Carpet Area - Show if has value (Apartment only) */}
//                 {hasValue(property.carpet_area) && (
//                   <>
//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         fullWidth
//                         label="Carpet Area"
//                         name="carpet_area"
//                         type="number"
//                         value={editedProperty?.carpet_area || ''}
//                         onChange={handleInputChange}
//                         variant="outlined"
//                         sx={{
//                           mb: 2,
//                           '& .MuiInputBase-root': {
//                             height: '56px'
//                           },
//                           '& .MuiInputLabel-root': {
//                             lineHeight: '1.2'
//                           }
//                         }}
//                         placeholder="Enter carpet area"
//                       />
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                       <FormControl fullWidth sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}>
//                         <InputLabel>Carpet Area Unit</InputLabel>
//                         <Select
//                           name="carpet_area_units"
//                           value={editedProperty?.carpet_area_units || 'Sq.Ft'}
//                           onChange={handleInputChange}
//                           label="Carpet Area Unit"
//                         >
//                           <MenuItem value="Sq.Ft">Sq. Ft</MenuItem>
//                           <MenuItem value="Sq.yards">Sq. yards</MenuItem>
//                           <MenuItem value="Sq.m">Sq. m</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </>
//                 )}
//                 {/* ✅ Built-up Area - Show if has value (Apartment only) */}
//                 {hasValue(property.built_up_area) && (
//                   <>
//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         fullWidth
//                         label="Built-up Area"
//                         name="built_up_area"
//                         type="number"
//                         value={editedProperty?.built_up_area || ''}
//                         onChange={handleInputChange}
//                         variant="outlined"
//                         sx={{
//                           mb: 2,
//                           '& .MuiInputBase-root': {
//                             height: '56px'
//                           },
//                           '& .MuiInputLabel-root': {
//                             lineHeight: '1.2'
//                           }
//                         }}
//                         placeholder="Enter built-up area"
//                       />
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                       <FormControl fullWidth sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}>
//                         <InputLabel>Built-up Area Unit</InputLabel>
//                         <Select
//                           name="built_up_area_units"
//                           value={editedProperty?.built_up_area_units || 'Sq.Ft'}
//                           onChange={handleInputChange}
//                           label="Built-up Area Unit"
//                         >
//                           <MenuItem value="Sq.Ft">Sq. Ft</MenuItem>
//                           <MenuItem value="Sq.yards">Sq. yards</MenuItem>
//                           <MenuItem value="Sq.m">Sq. m</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </>
//                 )}
//                 {/* ✅ Length - Show if has value */}
//                 {hasValue(property.length) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Length"
//                       name="length"
//                       type="number"
//                       value={editedProperty?.length || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Enter length"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Width - Show if has value */}
//                 {hasValue(property.width) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Width"
//                       name="width"
//                       type="number"
//                       value={editedProperty?.width || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Enter width"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Total Floors - Show if has value */}
//                 {hasValue(property.total_floors) && (
//                   <Grid item xs={12} md={4}>
//                     <TextField
//                       fullWidth
//                       label="Total Floors"
//                       name="total_floors"
//                       type="number"
//                       value={editedProperty?.total_floors || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Total floors in building"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Floor Number - Show if has value */}
//                 {hasValue(property.select_floor) && (
//                   <Grid item xs={12} md={4}>
//                     <TextField
//                       fullWidth
//                       label="Floor Number"
//                       name="select_floor"
//                       type="number"
//                       value={editedProperty?.select_floor || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Property floor number"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Construction Status - Show if has value */}
//                 {hasValue(property.construction_status) && (
//                   <Grid item xs={12} md={4}>
//                     <FormControl fullWidth sx={{
//                       mb: 2,
//                       '& .MuiInputBase-root': {
//                         height: '56px'
//                       },
//                       '& .MuiInputLabel-root': {
//                         lineHeight: '1.2'
//                       }
//                     }}>
//                       <InputLabel>Construction Status</InputLabel>
//                       <Select
//                         name="construction_status"
//                         value={editedProperty?.construction_status || ''}
//                         onChange={handleInputChange}
//                         label="Construction Status"
//                       >
//                         <MenuItem value="ready to move">Ready to Move</MenuItem>
//                         <MenuItem value="under construction">Under Construction</MenuItem>
//                         <MenuItem value="new launch">New Launch</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 )}
//                 {/* ✅ Ownership - Show if has value */}
//                 {hasValue(property.ownership) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Ownership"
//                       name="ownership"
//                       value={editedProperty?.ownership || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="e.g., Freehold, Leasehold"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Hub - Show if has value */}
//                 {hasValue(property.hub) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Hub/Location Hub"
//                       name="hub"
//                       value={editedProperty?.hub || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="e.g., Business Park, IT Hub"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Commercial Category - Show if has value */}
//                 {hasValue(property.commercial_catgory) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Commercial Category"
//                       name="commercial_catgory"
//                       value={editedProperty?.commercial_catgory || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       disabled
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px',
//                           backgroundColor: '#f5f5f5'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Enter commercial category"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ Commercial Asset Type - Show if has value */}
//                 {hasValue(property.commercial_asset_type) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="Commercial Asset Type"
//                       name="commercial_asset_type"
//                       value={editedProperty?.commercial_asset_type || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       disabled
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px',
//                           backgroundColor: '#f5f5f5'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Enter asset type"
//                     />
//                   </Grid>
//                 )}
//                 {/* ✅ UDS - Show if has value */}
//                 {hasValue(property.uds) && (
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       label="UDS (Undivided Share)"
//                       name="uds"
//                       type="number"
//                       value={editedProperty?.uds || ''}
//                       onChange={handleInputChange}
//                       variant="outlined"
//                       sx={{
//                         mb: 2,
//                         '& .MuiInputBase-root': {
//                           height: '56px'
//                         },
//                         '& .MuiInputLabel-root': {
//                           lineHeight: '1.2'
//                         }
//                       }}
//                       placeholder="Enter UDS value"
//                     />
//                   </Grid>
//                 )}
//               </Grid>
//             </Paper>

//             {/* ✅ Description Section - Show if has value */}
//             {hasValue(property.description) && (
//               <Paper elevation={0} sx={{ p: 2 }}>
//                 <Box sx={{
//                   borderLeft: '4px solid #4285F4',
//                   pl: 2,
//                   mb: 3,
//                   py: 0.5,
//                   backgroundColor: '#f5f8ff',
//                   width: '100%',
//                   textAlign: 'left'
//                 }}>
//                   <Typography variant="subtitle1" sx={{
//                     fontWeight: 600,
//                     fontFamily: 'Outfit',
//                     color: '#333'
//                   }}>
//                     Property Description
//                   </Typography>
//                 </Box>
//                 <TextField
//                   fullWidth
//                   label="Description"
//                   name="description"
//                   value={editedProperty?.description || ''}
//                   onChange={handleInputChange}
//                   variant="outlined"
//                   multiline
//                   rows={4}
//                   sx={{ mb: 2 }}
//                   placeholder="Describe your property with key features, condition, and surroundings"
//                 />
//               </Paper>
//             )}

//             {/* ✅ Content Section - Show if has value (for commercial plots) */}
//             {hasValue(property.content) && (
//               <Paper elevation={0} sx={{ p: 2 }}>
//                 <Box sx={{
//                   borderLeft: '4px solid #4285F4',
//                   pl: 2,
//                   mb: 3,
//                   py: 0.5,
//                   backgroundColor: '#f5f8ff',
//                   width: '100%',
//                   textAlign: 'left'
//                 }}>
//                   <Typography variant="subtitle1" sx={{
//                     fontWeight: 600,
//                     fontFamily: 'Outfit',
//                     color: '#333'
//                   }}>
//                     Additional Content
//                   </Typography>
//                 </Box>
//                 <TextField
//                   fullWidth
//                   label="Content"
//                   name="content"
//                   value={editedProperty?.content || ''}
//                   onChange={handleInputChange}
//                   variant="outlined"
//                   multiline
//                   rows={4}
//                   sx={{ mb: 2 }}
//                   placeholder="Additional information about the property"
//                 />
//               </Paper>
//             )}
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
//           <Button
//             onClick={() => setEditListingDialogOpen(false)}
//             variant="outlined"
//             sx={{ borderRadius: 2, textTransform: 'none', px: 3 }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={() => handleSaveChanges('listing')}
//             variant="contained"
//             color="primary"
//             disabled={isSaving}
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               bgcolor: '#4285F4',
//               '&:hover': {
//                 bgcolor: '#3367d6',
//               }
//             }}
//           >
//             {isSaving ? <CircularProgress size={24} /> : 'Save Changes'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ✅ NEW AMENITIES DIALOG - Matching PropertyDetails.jsx UI */}
//       <Dialog
//         open={amenitiesDialogOpen}
//         onClose={() => setAmenitiesDialogOpen(false)}
//         maxWidth="lg"
//         fullWidth
//         fullScreen={window.innerWidth < 600}
//         sx={{
//           '& .MuiDialog-paper': {
//             borderRadius: window.innerWidth < 600 ? 0 : '24px',
//             maxHeight: window.innerWidth < 600 ? '100vh' : '90vh',
//             margin: window.innerWidth < 600 ? 0 : 2,
//           }
//         }}
//       >
//         <DialogContent sx={{ p: window.innerWidth < 600 ? 2 : 4, pb: window.innerWidth < 600 ? 10 : 4 }}>
//           <Typography
//             variant={window.innerWidth < 600 ? "h5" : "h4"}
//             sx={{
//               fontFamily: 'Outfit',
//               fontWeight: 500,
//               color: 'black',
//               mb: window.innerWidth < 600 ? 2 : 4,
//               textAlign: window.innerWidth < 600 ? 'center' : 'left'
//             }}
//           >
//             Add Property Amenities
//           </Typography>

//           {/* Society Amenities */}
//           <Box sx={{ mb: window.innerWidth < 600 ? 3 : 4 }}>
//             <Typography
//               variant={window.innerWidth < 600 ? "h6" : "h5"}
//               sx={{
//                 fontFamily: 'Outfit',
//                 fontWeight: 500,
//                 color: '#666',
//                 mb: 2,
//                 fontSize: window.innerWidth < 600 ? '18px' : '24px'
//               }}
//             >
//               Society Amenities
//             </Typography>
//             <Grid container spacing={window.innerWidth < 600 ? 1.5 : 2}>
//               {societyAmenitiesData.map((amenity, index) => {
//                 const isChecked = editedProperty?.society_aminities ?
//                   editedProperty.society_aminities.split(', ').includes(amenity.name) : false;
                
//                 return (
//                   <Grid item xs={6} sm={4} md={2.4} key={`society-${index}`}>
//                     <Card
//                       onClick={() => {
//                         const currentItems = editedProperty?.society_aminities ?
//                           editedProperty.society_aminities.split(', ') : [];
                        
//                         let updatedItems;
//                         if (isChecked) {
//                           updatedItems = currentItems.filter(item => item !== amenity.name);
//                         } else {
//                           updatedItems = [...currentItems, amenity.name];
//                         }
                        
//                         setEditedProperty(prev => ({
//                           ...prev,
//                           society_aminities: updatedItems.filter(item => item).join(', ')
//                         }));
//                       }}
//                       sx={{
//                         height: window.innerWidth < 600 ? 100 : 120,
//                         cursor: 'pointer',
//                         border: isChecked ? '2px solid #4f26ff' : '1px solid #d0d0d0',
//                         backgroundColor: isChecked ? '#eeeaff' : 'white',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         p: 1,
//                         borderRadius: '12px',
//                         transition: 'all 0.2s ease',
//                         '&:hover': {
//                           borderColor: '#4f26ff',
//                           transform: 'translateY(-2px)',
//                           boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
//                         },
//                         '&:active': {
//                           transform: 'translateY(0px)',
//                         }
//                       }}
//                     >
//                       <CardContent sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         p: `${window.innerWidth < 600 ? 6 : 8}px !important`,
//                         textAlign: 'center'
//                       }}>
//                         <Box
//                           component="img"
//                           src={amenity.icon}
//                           alt={amenity.name}
//                           sx={{
//                             width: window.innerWidth < 600 ? 30 : 40,
//                             height: window.innerWidth < 600 ? 30 : 40,
//                             mb: 0.5,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <Typography sx={{
//                           textAlign: 'center',
//                           fontSize: window.innerWidth < 600 ? '12px' : '14px',
//                           fontFamily: 'Outfit',
//                           color: isChecked ? '#4f26ff' : 'black',
//                           fontWeight: isChecked ? 500 : 400,
//                           lineHeight: 1.2,
//                           wordBreak: 'break-word',
//                           hyphens: 'auto'
//                         }}>
//                           {amenity.name}
//                         </Typography>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </Box>

//           {/* Furnishing Facilities */}
//           <Box sx={{ mb: window.innerWidth < 600 ? 3 : 4 }}>
//             <Typography
//               variant={window.innerWidth < 600 ? "h6" : "h5"}
//               sx={{
//                 fontFamily: 'Outfit',
//                 fontWeight: 500,
//                 color: '#666',
//                 mb: 2,
//                 fontSize: window.innerWidth < 600 ? '18px' : '24px'
//               }}
//             >
//               Furnishing Facilities
//             </Typography>
//             <Grid container spacing={window.innerWidth < 600 ? 1.5 : 2}>
//               {furnishingFacilitiesData.map((facility, index) => {
//                 const isChecked = editedProperty?.furnish_facilities ?
//                   editedProperty.furnish_facilities.split(', ').includes(facility.name) : false;
                
//                 return (
//                   <Grid item xs={6} sm={4} md={2.4} key={`furnishing-${index}`}>
//                     <Card
//                       onClick={() => {
//                         const currentItems = editedProperty?.furnish_facilities ?
//                           editedProperty.furnish_facilities.split(', ') : [];
                        
//                         let updatedItems;
//                         if (isChecked) {
//                           updatedItems = currentItems.filter(item => item !== facility.name);
//                         } else {
//                           updatedItems = [...currentItems, facility.name];
//                         }
                        
//                         setEditedProperty(prev => ({
//                           ...prev,
//                           furnish_facilities: updatedItems.filter(item => item).join(', ')
//                         }));
//                       }}
//                       sx={{
//                         height: window.innerWidth < 600 ? 100 : 120,
//                         cursor: 'pointer',
//                         border: isChecked ? '2px solid #4f26ff' : '1px solid #d0d0d0',
//                         backgroundColor: isChecked ? '#eeeaff' : 'white',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         p: 1,
//                         borderRadius: '12px',
//                         transition: 'all 0.2s ease',
//                         '&:hover': {
//                           borderColor: '#4f26ff',
//                           transform: 'translateY(-2px)',
//                           boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
//                         },
//                         '&:active': {
//                           transform: 'translateY(0px)',
//                         }
//                       }}
//                     >
//                       <CardContent sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         p: `${window.innerWidth < 600 ? 6 : 8}px !important`,
//                         textAlign: 'center'
//                       }}>
//                         <Box
//                           component="img"
//                           src={facility.icon}
//                           alt={facility.name}
//                           sx={{
//                             width: window.innerWidth < 600 ? 30 : 40,
//                             height: window.innerWidth < 600 ? 30 : 40,
//                             mb: 0.5,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <Typography sx={{
//                           textAlign: 'center',
//                           fontSize: window.innerWidth < 600 ? '12px' : '14px',
//                           fontFamily: 'Outfit',
//                           color: isChecked ? '#4f26ff' : 'black',
//                           fontWeight: isChecked ? 500 : 400,
//                           lineHeight: 1.2,
//                           wordBreak: 'break-word'
//                         }}>
//                           {facility.name}
//                         </Typography>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </Box>

//           {/* Other Facilities */}
//           <Box sx={{ mb: window.innerWidth < 600 ? 3 : 4 }}>
//             <Typography
//               variant={window.innerWidth < 600 ? "h6" : "h5"}
//               sx={{
//                 fontFamily: 'Outfit',
//                 fontWeight: 500,
//                 color: '#666',
//                 mb: 2,
//                 fontSize: window.innerWidth < 600 ? '18px' : '24px'
//               }}
//             >
//               Other Facilities
//             </Typography>
//             <Grid container spacing={window.innerWidth < 600 ? 1.5 : 2}>
//               {otherFacilitiesData.map((facility, index) => {
//                 const isChecked = editedProperty?.other_facilities ?
//                   editedProperty.other_facilities.split(', ').includes(facility) : false;
                
//                 return (
//                   <Grid item xs={6} sm={4} md={3} key={`other-facility-${index}`}>
//                     <Card
//                       onClick={() => {
//                         const currentItems = editedProperty?.other_facilities ?
//                           editedProperty.other_facilities.split(', ') : [];
                        
//                         let updatedItems;
//                         if (isChecked) {
//                           updatedItems = currentItems.filter(item => item !== facility);
//                         } else {
//                           updatedItems = [...currentItems, facility];
//                         }
                        
//                         setEditedProperty(prev => ({
//                           ...prev,
//                           other_facilities: updatedItems.filter(item => item).join(', ')
//                         }));
//                       }}
//                       sx={{
//                         height: window.innerWidth < 600 ? 60 : 70,
//                         cursor: 'pointer',
//                         border: isChecked ? '2px solid #4f26ff' : '1px solid #d0d0d0',
//                         backgroundColor: isChecked ? '#eeeaff' : 'white',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         px: 2,
//                         borderRadius: '12px',
//                         transition: 'all 0.2s ease',
//                         '&:hover': {
//                           borderColor: '#4f26ff',
//                           transform: 'translateY(-2px)',
//                           boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
//                         },
//                         '&:active': {
//                           transform: 'translateY(0px)',
//                         }
//                       }}
//                     >
//                       <CardContent sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         p: `${window.innerWidth < 600 ? 8 : 12}px !important`,
//                         width: '100%'
//                       }}>
//                         <Typography sx={{
//                           textAlign: 'center',
//                           fontSize: window.innerWidth < 600 ? '13px' : '15px',
//                           fontFamily: 'Outfit',
//                           color: isChecked ? '#4f26ff' : 'black',
//                           fontWeight: isChecked ? 500 : 400,
//                           lineHeight: 1.2,
//                           wordBreak: 'break-word'
//                         }}>
//                           {facility}
//                         </Typography>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{
//           p: window.innerWidth < 600 ? 2 : 3,
//           justifyContent: window.innerWidth < 600 ? 'center' : 'space-between',
//           flexDirection: window.innerWidth < 600 ? 'row' : 'row',
//           gap: window.innerWidth < 600 ? 2 : 0,
//           position: window.innerWidth < 600 ? 'fixed' : 'relative',
//           bottom: window.innerWidth < 600 ? 0 : 'auto',
//           left: window.innerWidth < 600 ? 0 : 'auto',
//           right: window.innerWidth < 600 ? 0 : 'auto',
//           backgroundColor: 'white',
//           borderTop: window.innerWidth < 600 ? '1px solid #e0e0e0' : 'none'
//         }}>
//           <Button
//             onClick={() => {
//               // Cancel - Clear all selections
//               setEditedProperty(prev => ({
//                 ...prev,
//                 society_aminities: '',
//                 furnish_facilities: '',
//                 other_facilities: ''
//               }));
//               setAmenitiesDialogOpen(false);
//             }}
//             variant="contained"
//             sx={{
//               width: window.innerWidth < 600 ? '50%' : 180,
//               height: window.innerWidth < 600 ? 50 : 60,
//               bgcolor: '#c2c2c2',
//               borderRadius: '10px',
//               border: '1px solid #d0d0d0',
//               color: '#020202',
//               fontSize: window.innerWidth < 600 ? 16 : 18,
//               fontFamily: "'Outfit', Helvetica",
//               fontWeight: 'normal',
//               order: 1,
//               '&:hover': {
//                 bgcolor: '#b0b0b0'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={() => handleSaveChanges('amenities')}
//             variant="contained"
//             disabled={isSaving}
//             sx={{
//               width: window.innerWidth < 600 ? '50%' : 180,
//               height: window.innerWidth < 600 ? 50 : 60,
//               bgcolor: '#4f26ff',
//               borderRadius: '10px',
//               color: 'white',
//               fontSize: window.innerWidth < 600 ? 16 : 18,
//               fontFamily: "'Outfit', Helvetica",
//               fontWeight: 'normal',
//               order: 2,
//               '&:hover': {
//                 bgcolor: '#3d1fd9'
//               }
//             }}
//           >
//                  {isSaving ? <CircularProgress size={24} color="inherit" /> : 'OK'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Alert Dialog */}
//       <Dialog
//         open={alertDialog.open}
//         onClose={handleAlertClose}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           color: alertDialog.severity === 'success' ? '#2e7d32' : '#d32f2f',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2
//         }}>
//           {alertDialog.severity === 'success' ? 'Success' : 'Error'}
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3, pb: 1 }}>
//           <DialogContentText>
//             {alertDialog.message}
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, py: 2 }}>
//           <Button
//             onClick={handleAlertClose}
//             variant="contained"
//             color={alertDialog.severity === 'success' ? 'primary' : 'error'}
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//             }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default EditProperties;



import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Grid,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  DialogContentText,
  Chip,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  CircularProgress,
  Paper,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HotelIcon from '@mui/icons-material/Hotel';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ElevatorIcon from '@mui/icons-material/Elevator';
import VideocamIcon from '@mui/icons-material/Videocam';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import HomeIcon from '@mui/icons-material/Home';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import YardIcon from '@mui/icons-material/Yard';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import PoolIcon from '@mui/icons-material/Pool';
import PetsIcon from '@mui/icons-material/Pets';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import TvIcon from '@mui/icons-material/Tv';
import ChairIcon from '@mui/icons-material/Chair';
import KitchenIcon from '@mui/icons-material/Kitchen';
import WeekendIcon from '@mui/icons-material/Weekend';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import MicrowaveIcon from '@mui/icons-material/Microwave';
import PowerIcon from '@mui/icons-material/Power';
import SecurityIcon from '@mui/icons-material/Security';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import ParkIcon from '@mui/icons-material/Park';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Loader from '../Loader/Loader';
import { selectUser } from '../Commonlibs/userSlice';

// Import amenity icons
import liftIcon from '../assets/applift.png';
import cctvIcon from '../assets/appctv.png';
import gymIcon from '../assets/appfit.png';
import gardenIcon from '../assets/appgarden.png';
import kidsAreaIcon from '../assets/appkids.png';
import sportsIcon from '../assets/appsport.png';
import swimmingPoolIcon from '../assets/appswim.png';
import intercomIcon from '../assets/appinter.png';
import gatedCommunityIcon from '../assets/appgate.png';
import clubHouseIcon from '../assets/appclub.png';
import communityHallIcon from '../assets/appcom.png';
import regularWaterSupplyIcon from '../assets/appregul.png';
import powerBackupIcon from '../assets/apppower.png';
import petAllowedIcon from '../assets/apppet.png';
import diningTableIcon from '../assets/appdinner.png';
import washingMachineIcon from '../assets/appwash.png';
import sofaIcon from '../assets/appsofa.png';
import microwaveIcon from '../assets/appmicro.png';
import fridgeIcon from '../assets/appfridge.png';
import waterPurifierIcon from '../assets/appwater.png';
import gasPipelineIcon from '../assets/appgas.png';
import acIcon from '../assets/appac.png';
import bedIcon from '../assets/appbed.png';
import tvIcon from '../assets/apptv.png';
import cupboardIcon from '../assets/appcup.png';
import geyserIcon from '../assets/appgeyser.png';

// Define amenities data arrays
const societyAmenitiesData = [
  { name: "Lift", icon: liftIcon, selected: false },
  { name: "CCTV", icon: cctvIcon, selected: false },
  { name: "Gym", icon: gymIcon, selected: false },
  { name: "Garden", icon: gardenIcon, selected: false },
  { name: "Kids Area", icon: kidsAreaIcon, selected: false },
  { name: "Sports", icon: sportsIcon, selected: false },
  { name: "Swimming Pool", icon: swimmingPoolIcon, selected: false },
  { name: "Intercom", icon: intercomIcon, selected: false },
  { name: "Gated Community", icon: gatedCommunityIcon, selected: false },
  { name: "Club House", icon: clubHouseIcon, selected: false },
  { name: "Community Hall", icon: communityHallIcon, selected: false },
  { name: "Regular Water Supply", icon: regularWaterSupplyIcon, selected: false },
  { name: "Power backup", icon: powerBackupIcon, selected: false },
  { name: "Pet Allowed", icon: petAllowedIcon, selected: false },
];

const furnishingFacilitiesData = [
  { name: "Dining Table", icon: diningTableIcon, selected: false },
  { name: "Washing Machine", icon: washingMachineIcon, selected: false },
  { name: "Sofa", icon: sofaIcon, selected: false },
  { name: "Microwave", icon: microwaveIcon, selected: false },
  { name: "Fridge", icon: fridgeIcon, selected: false },
  { name: "Water Purifier", icon: waterPurifierIcon, selected: false },
  { name: "Gas Pipeline", icon: gasPipelineIcon, selected: false },
  { name: "AC", icon: acIcon, selected: false },
  { name: "Bed", icon: bedIcon, selected: false },
  { name: "TV", icon: tvIcon, selected: false },
  { name: "Cupboard", icon: cupboardIcon, selected: false },
  { name: "Geyser", icon: geyserIcon, selected: false },
];

const otherFacilitiesData = [
  "Hospital",
  "School",
  "Park",
  "Shopping Mall",
  "Metro Station",
  "Bus Stop",
  "Restaurant",
  "Pharmacy"
];

const EditProperties = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const [loading, setLoading] = useState(true);
  const [property, setProperty] = useState(null);
  const [error, setError] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
  const [mediaType, setMediaType] = useState('image');
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [editListingDialogOpen, setEditListingDialogOpen] = useState(false);
  const [amenitiesDialogOpen, setAmenitiesDialogOpen] = useState(false);
  const [editedProperty, setEditedProperty] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [imagesToDelete, setImagesToDelete] = useState([]);
  const [alertDialog, setAlertDialog] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [photosDialogOpen, setPhotosDialogOpen] = useState(false);
  const [uploadedPhotos, setUploadedPhotos] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [userProfile, setUserProfile] = useState({
    full_name: '',
    email_id: '',
    contact_number: '',
    profile_image: null
  });

  // Helper function to check if a field has a valid value
  const hasValue = (value) => {
    return value !== null && value !== undefined && value !== '';
  };

  // Check if amenities should be shown
  const shouldShowAmenities = () => {
    if (!property) return false;
    const propertyType = property.property_type?.toLowerCase();
    const assetType = property.asset_type?.toLowerCase();
    return propertyType === 'residential' && assetType !== 'plot' && assetType !== 'agriculture land';
  };

  // Function to get amenity icon
  const getAmenityIcon = (amenityType) => {
    const amenityIconMap = {
      'Lift': ElevatorIcon,
      'Parking': LocalParkingIcon,
      'Gym': FitnessCenterIcon,
      'Swimming Pool': PoolIcon,
      'Garden': YardIcon,
      'Playground': SportsSoccerIcon,
      'Club House': HomeIcon,
      'Indoor Games': SportsBaseballIcon,
      'Jogging Track': SportsBaseballIcon,
      'Security': SecurityIcon,
      'Pet Allowed': PetsIcon,
      'AC': AcUnitIcon,
      'TV': TvIcon,
      'Sofa': WeekendIcon,
      'Bed': HotelIcon,
      'Wardrobe': ChairIcon,
      'Refrigerator': KitchenIcon,
      'Washing Machine': LocalLaundryServiceIcon,
      'Microwave': MicrowaveIcon,
      'Power Backup': PowerIcon,
      'CCTV': VideocamIcon,
      'Children Area': ChildCareIcon,
      'Modular Kitchen': KitchenIcon,
      'Dining Table': WeekendIcon,
      'Fire Safety': SecurityIcon,
      'Visitor Parking': LocalParkingIcon,
      'Water Supply': PoolIcon,
      'Rainwater Harvesting': PoolIcon,
      'Waste Disposal': DeleteIcon,
      'Hospital': HomeIcon,
      'School': HomeIcon,
      'Park': ParkIcon,
      'Shopping Mall': HomeIcon,
      'Metro Station': HomeIcon,
      'Bus Stop': HomeIcon,
      'Restaurant': HomeIcon,
      'Pharmacy': HomeIcon,
      'Gated Community': SecurityIcon,
      'Intercom': PhoneIcon,
      'Community Hall': HomeIcon,
      'Regular Water Supply': PoolIcon,
      'Water Purifier': PoolIcon,
      'Gas Pipeline': KitchenIcon,
      'Geyser': PowerIcon,
      'Cupboard': ChairIcon,
      'Kids Area': ChildCareIcon,
      'Sports': SportsSoccerIcon,
      'Fridge': KitchenIcon
    };

    const IconComponent = amenityIconMap[amenityType] || HomeIcon;
    return <IconComponent sx={{ color: '#666', fontSize: 20 }} />;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return `${currency}0`;
    return `${currency}${Number(amount).toLocaleString()}`;
  };

  // ✅ FIXED: Updated processMedia function to handle API response format
  const processMedia = (mediaData) => {
    if (!mediaData || !Array.isArray(mediaData)) return [];
    
    return mediaData
      .map(item => {
        try {
          if (typeof item === 'object' && item?.image) {
            const imageData = item.image.startsWith('data:')
              ? item.image
              : `data:image/png;base64,${item.image}`;
            
            return {
              type: 'image',
              data: imageData,
              id: item.id || `temp-${Math.random()}`,
              image_name: item.image_name || 'Property Image'
            };
          }
          return null;
        } catch (error) {
          console.error('Error processing media item:', error);
          return null;
        }
      })
      .filter(item => item !== null);
  };

  const getMainImage = (mediaArray) => {
    if (!mediaArray || mediaArray.length === 0) return null;
    const firstImage = mediaArray.find(item => item.type === 'image');
    return firstImage ? firstImage.data : null;
  };

  const getAdditionalMedia = (mediaArray) => {
    if (!mediaArray || mediaArray.length <= 1) return [];
    return mediaArray.slice(1).slice(0, 3);
  };

  const handleMediaOpen = (media, type, index) => {
    setSelectedMedia(media);
    setMediaType(type);
    setCurrentMediaIndex(index !== undefined ? index : 0);
    setMediaDialogOpen(true);
  };

  const handleMediaClose = () => {
    setMediaDialogOpen(false);
    setSelectedMedia(null);
  };

  const handleNextMedia = (allMedia) => {
    if (currentMediaIndex < allMedia.length - 1) {
      const nextIndex = currentMediaIndex + 1;
      const nextMedia = allMedia[nextIndex];
      setSelectedMedia(nextMedia.data);
      setMediaType(nextMedia.type);
      setCurrentMediaIndex(nextIndex);
    }
  };

  const handlePrevMedia = (allMedia) => {
    if (currentMediaIndex > 0) {
      const prevIndex = currentMediaIndex - 1;
      const prevMedia = allMedia[prevIndex];
      setSelectedMedia(prevMedia.data);
      setMediaType(prevMedia.type);
      setCurrentMediaIndex(prevIndex);
    }
  };

  // ✅ FIXED: Updated handleFileUpload
  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    
    if (uploadedPhotos.length + files.length > 10) {
      setAlertDialog({
        open: true,
        message: `You can only upload a maximum of 10 images. Currently you have ${uploadedPhotos.length} images.`,
        severity: 'error'
      });
      return;
    }

    const validImages = files.filter(file => {
      const isValidType = file.type.startsWith('image/');
      if (!isValidType) {
        console.warn(`${file.name} is not a valid image file`);
      }
      return isValidType;
    });

    if (validImages.length !== files.length) {
      setAlertDialog({
        open: true,
        message: 'Some files were skipped (invalid image type)',
        severity: 'warning'
      });
    }

    validImages.forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newMedia = {
          id: `temp-${Date.now()}-${Math.random()}`,
          name: file.name,
          size: file.size,
          type: 'image',
          preview: e.target.result,
          file: file,
          isNew: true
        };
        setUploadedPhotos(prev => [...prev, newMedia]);
      };
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
        setAlertDialog({
          open: true,
          message: `Failed to read file: ${file.name}`,
          severity: 'error'
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = '';
  };

  // ✅ FIXED: Updated handleDeleteMedia
  const handleDeleteMedia = (id) => {
    const photoToDelete = uploadedPhotos.find(item => item.id === id);
    
    if (photoToDelete && !photoToDelete.isNew) {
      setImagesToDelete(prev => [...prev, id]);
    }
    
    setUploadedPhotos(prev => prev.filter(item => item.id !== id));
  };

  // ✅ FIXED: Updated handleSaveMedia
  const handleSaveMedia = async () => {
    setIsUploading(true);
    
    try {
      // Step 1: Delete marked images
      if (imagesToDelete.length > 0) {
        console.log('=== Deleting Images ===');
        console.log('Images to delete:', imagesToDelete);
        
        for (const imageId of imagesToDelete) {
          try {
            const deletePayload = {
              property_id: property?.id,
              seller_id: user?.id || property?.seller_id,
              image_id: imageId
            };
            
            console.log('Deleting image:', deletePayload);
            
            const deleteResponse = await fetch('https://propertydealstalk.com/api/property/removePropertyImage', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(deletePayload)
            });
            
            const deleteData = await deleteResponse.json();
            console.log('Delete response:', deleteData);
            
            if (deleteData.status !== "SUCCESS") {
              console.warn(`Failed to delete image ${imageId}:`, deleteData.message);
            }
          } catch (deleteError) {
            console.error(`Error deleting image ${imageId}:`, deleteError);
          }
        }
        
        setImagesToDelete([]);
      }

      // Step 2: Upload new images
      const newPhotos = uploadedPhotos.filter(photo => photo.isNew && photo.file);
      
      if (newPhotos.length > 0) {
        const formData = new FormData();
        formData.append('property_id', String(property?.id));
        formData.append('seller_id', String(user?.id || property?.seller_id));
        
        newPhotos.forEach((photo) => {
          formData.append('property_images', photo.file, photo.file.name);
        });
        
        console.log('=== Uploading New Images ===');
        console.log('Number of new images:', newPhotos.length);
        
        const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
          method: 'POST',
          body: formData,
        });
        
        const responseText = await response.text();
        console.log('Upload response:', responseText);
        
        let data;
        try {
          data = JSON.parse(responseText);
        } catch (parseError) {
          throw new Error(`Server returned invalid response: ${responseText.substring(0, 200)}`);
        }
        
        if (!response.ok || data.status !== "SUCCESS") {
          throw new Error(data.message || 'Failed to upload images');
        }
      }

      // Step 3: Refresh property data
      console.log('=== Refreshing Property Data ===');
      const refreshResponse = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${property?.id}&timestamp=${Date.now()}`);
      const refreshData = await refreshResponse.json();
      
      if (refreshData.status === "SUCCESS") {
        // ✅ FIXED: Handle array response
        const propertyData = Array.isArray(refreshData.result) ? refreshData.result[0] : refreshData.result;
        setProperty(propertyData);
        
        const allMedia = processMedia(propertyData?.images || []);
        const photos = allMedia.filter(item => item.type === 'image').map(item => ({
          id: item.id,
          name: item.image_name || 'Property Image',
          preview: item.data,
          type: 'image',
          isNew: false
        }));
        setUploadedPhotos(photos);
      }
      
      setPhotosDialogOpen(false);
      
      const deletedCount = imagesToDelete.length;
      const uploadedCount = newPhotos.length;
      let message = '';
      
      if (deletedCount > 0 && uploadedCount > 0) {
        message = `Deleted ${deletedCount} image(s) and uploaded ${uploadedCount} new image(s)!`;
      } else if (deletedCount > 0) {
        message = `Successfully deleted ${deletedCount} image(s)!`;
      } else if (uploadedCount > 0) {
        message = `Successfully uploaded ${uploadedCount} new image(s)!`;
      } else {
        message = 'No changes made';
      }
      
      setAlertDialog({
        open: true,
        message: message,
        severity: 'success'
      });
    } catch (error) {
      console.error('=== Save Media Error ===');
      console.error('Error:', error);
      setAlertDialog({
        open: true,
        message: `Failed to save changes: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsUploading(false);
    }
  };

  // ✅ FIXED: Updated useEffect to handle array response
  useEffect(() => {
    const fetchPropertyDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`);
        const data = await response.json();
        
        if (data.status === "SUCCESS") {
          // ✅ FIX: Handle array response
          const propertyData = Array.isArray(data.result) ? data.result[0] : data.result;
          
          if (propertyData) {
            setProperty(propertyData);
            setEditedProperty(propertyData);
          } else {
            setError('Property not found');
          }
        } else {
          setError('Failed to fetch property details');
        }
      } catch (error) {
        setError('Error fetching property details');
        console.error('Error fetching property details:', error);
      } finally {
        setLoading(false);
      }
    };

    if (propertyId) {
      fetchPropertyDetails();
    }
  }, [propertyId]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        if (!user?.id) return;
        
        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${user.id}`);
        const data = await response.json();
        
        if (data.status === "SUCCESS") {
          setUserProfile({
            full_name: data.result.full_name || '',
            email_id: data.result.email_id || '',
            contact_number: data.result.contact_number || '',
            profile_image: data.result.profile_image || null
          });
        }
      } catch (err) {
        console.error('Error fetching user profile:', err);
      }
    };

    fetchUserProfile();
  }, [user?.id]);

  const handleEditProperty = (section) => {
    if (section === 'listing') {
      setEditListingDialogOpen(true);
    } else if (section === 'amenities') {
      if (!shouldShowAmenities()) {
        setAlertDialog({
          open: true,
          message: 'Amenities are not applicable for this property type',
          severity: 'error'
        });
        return;
      }
      setAmenitiesDialogOpen(true);
    } else if (section === 'photos') {
      setPhotosDialogOpen(true);
      
      const allMedia = processMedia(property?.images || []);
      const photos = allMedia.filter(item => item.type === 'image').map(item => ({
        id: item.id,
        name: item.image_name || 'Property Image',
        preview: item.data,
        type: 'image',
        isNew: false
      }));
      setUploadedPhotos(photos);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedProperty(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSaveChanges = async (dialogType) => {
    try {
      setIsSaving(true);
      
      const payload = {
        property_id: editedProperty?.id,
        seller_id: user?.id || editedProperty?.seller_id || 1,
      };

      if (dialogType === 'listing') {
        const numericFields = [
          'asking_price', 'property_size', 'bhk', 'bathrooms',
          'total_floors', 'select_floor', 'age_of_property',
          'monthly_rent', 'carpet_area', 'built_up_area',
          'length', 'width'
        ];

        const fieldsToCheck = [
          'property_name', 'location', 'area_name', 'asking_price',
          'currency', 'property_size', 'property_size_units', 'bhk',
          'bathrooms', 'description', 'total_floors', 'select_floor',
          'furnish_type', 'negotiable', 'age_of_property',
          'construction_status', 'full_address', 'youtube_link',
          'carpet_area', 'carpet_area_units', 'built_up_area',
          'built_up_area_units', 'monthly_rent', 'security_deposit',
          'available_from', 'length', 'width', 'ownership',
          'commercial_catgory', 'commercial_asset_type', 'hub', 'content'
        ];

        fieldsToCheck.forEach(field => {
          if (editedProperty?.[field] !== undefined && 
              editedProperty?.[field] !== null && 
              editedProperty?.[field] !== '') {
            if (numericFields.includes(field)) {
              const numValue = Number(editedProperty[field]);
              if (!isNaN(numValue)) {
                payload[field] = numValue;
              }
            } else if (field === 'negotiable') {
              payload[field] = editedProperty[field] === 'true' || editedProperty[field] === true;
            } else {
              payload[field] = editedProperty[field];
            }
          }
        });
      } else if (dialogType === 'amenities') {
        if (!shouldShowAmenities()) {
          setAlertDialog({
            open: true,
            message: 'Amenities are not applicable for this property type',
            severity: 'error'
          });
          setIsSaving(false);
          return;
        }
        
        payload.society_aminities = editedProperty?.society_aminities || '';
        payload.furnish_facilities = editedProperty?.furnish_facilities || '';
        payload.other_facilities = editedProperty?.other_facilities || '';
        payload.facilities_distance = editedProperty?.facilities_distance || '';
      }

      console.log('Saving payload:', payload);

      const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
        // ✅ FIXED: Handle array response
        const refreshResponse = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}&timestamp=${new Date().getTime()}`);
        const refreshData = await refreshResponse.json();
        
        if (refreshData.status === "SUCCESS") {
          const propertyData = Array.isArray(refreshData.result) ? refreshData.result[0] : refreshData.result;
          setProperty(propertyData);
          setEditedProperty(propertyData);
        }

        if (dialogType === 'listing') {
          setEditListingDialogOpen(false);
        } else if (dialogType === 'amenities') {
          setAmenitiesDialogOpen(false);
        }

        setAlertDialog({
          open: true,
          message: 'Property updated successfully!',
          severity: 'success'
        });
      } else {
        throw new Error(data.message || 'Failed to update property');
      }
    } catch (error) {
      console.error('Error updating property:', error);
      setAlertDialog({
        open: true,
        message: error.message || 'Failed to update property. Please try again.',
        severity: 'error'
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleAlertClose = () => {
    setAlertDialog(prev => ({ ...prev, open: false }));
  };

  if (loading) return <Loader />;

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
        <Typography variant="h6" color="error" gutterBottom>
          {error}
        </Typography>
        <Button variant="contained" onClick={() => navigate('/sell-properties')}>
          Back to Properties
        </Button>
      </Box>
    );
  }

  // ✅ FIXED: Added safety check
  if (!property || !editedProperty) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
        <Typography variant="h6" gutterBottom>
          Property not found
        </Typography>
        <Button variant="contained" onClick={() => navigate('/sell-properties')}>
          Back to Properties
        </Button>
      </Box>
    );
  }

  const allMedia = processMedia(property?.images || []);
  const mainImageSrc = getMainImage(allMedia);
  const additionalMedia = getAdditionalMedia(allMedia);
  const remainingMediaCount = allMedia.length - 4 > 0 ? allMedia.length - 4 : 0;

  const calculateBuiltYear = () => {
    if (!hasValue(property?.age_of_property)) return null;
    const age = Number(property.age_of_property);
    if (isNaN(age) || age < 0 || age > 100) return null;
    return new Date().getFullYear() - age;
  };

  const propertyData = {
    id: property?.id,
    price: property?.category === 'rent' && hasValue(property?.monthly_rent)
      ? formatCurrency(property.monthly_rent, property.currency) + '/month'
      : formatCurrency(property?.asking_price, property?.currency),
    title: property?.property_name || '',
    location: `${property?.area_name || ''}, ${property?.location || ''}`,
    date: formatDate(property?.createdAt),
    views: '0 Views',
    beds: property?.bhk || 0,
    baths: property?.bathrooms || 0,
    area: `${property?.property_size || 0} ${property?.property_size_units || ''}`,
    mainImage: mainImageSrc,
    additionalMedia: additionalMedia,
    description: property?.description || 'This property is currently under verification. Update the description to provide more details about your property.',
    propertyType: `${property?.property_type || ''} - ${property?.asset_type || ''}`,
    propertyID: `#PD${(property?.id || 0).toString().padStart(6, '0')}`,
    builtYear: calculateBuiltYear(),
    status: property?.status,
    amenities: property?.society_aminities ? property.society_aminities.split(', ') : [],
    furnishFacilities: property?.furnish_facilities ? property.furnish_facilities.split(', ') : [],
    otherFacilities: property?.other_facilities ? property.other_facilities.split(', ') : [],
    seller: property?.seller || {
      full_name: 'Owner',
      email_id: 'N/A',
      contact_number: 'N/A'
    }
  };

  const allAmenities = [
    ...propertyData.amenities,
    ...propertyData.furnishFacilities,
    ...propertyData.otherFacilities
  ];

  return (
    <>
      <Card sx={{
        width: '100%',
        maxWidth: '100%',
        borderRadius: 2,
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        mb: 3,
        marginTop: { xs: '30px', md: '5px' },
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          height: { xs: 'auto', md: '300px' }
        }}>
          <Box sx={{
            width: { xs: '100%', md: '70%' },
            height: { xs: '200px', md: '100%' },
            position: 'relative',
            cursor: propertyData.mainImage ? 'pointer' : 'default',
            bgcolor: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
            onClick={() => propertyData.mainImage && handleMediaOpen(propertyData.mainImage, 'image', 0)}>
            {propertyData.mainImage ? (
              <CardMedia
                component="img"
                sx={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                }}
                image={propertyData.mainImage}
                alt={propertyData.title}
              />
            ) : (
              <Typography variant="body1" color="text.secondary">
                No Media
              </Typography>
            )}
            {allMedia.length > 0 && (
              <Box sx={{
                position: 'absolute',
                bottom: 10,
                right: 10,
                bgcolor: 'rgba(0,0,0,0.6)',
                color: 'white',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                fontSize: '0.75rem'
              }}>
                1/{allMedia.length}
              </Box>
            )}
            <Button
              variant="contained"
              size="small"
              sx={{
                position: 'absolute',
                top: 10,
                right: 10,
                bgcolor: 'rgba(0,0,0,0.7)',
                color: 'white',
                borderRadius: 1,
                textTransform: 'none',
                '&:hover': {
                  bgcolor: 'rgba(0,0,0,0.8)',
                }
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleEditProperty('photos');
              }}
            >
              Manage Photos
            </Button>
            {propertyData.status && (
              <Box sx={{
                position: 'absolute',
                top: 10,
                left: 10,
                backgroundColor: propertyData.status === 'active' ? '#10b981' :
                  propertyData.status === 'under_verification' ? '#f59e0b' : 'rgba(0,0,0,0.7)',
                color: 'white',
                padding: '4px 10px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: 500,
                textTransform: 'capitalize'
              }}>
                {propertyData.status.replace(/_/g, ' ')}
              </Box>
            )}
          </Box>

          <Box sx={{
            width: { xs: '100%', md: '30%' },
            height: { xs: 'auto', md: '100%' },
            display: 'flex',
            flexDirection: { xs: 'row', md: 'column' },
          }}>
            {propertyData.additionalMedia.length > 0 ? (
              propertyData.additionalMedia.map((media, index) => (
                <Box
                  key={media.id || index}
                  sx={{
                    flex: 1,
                    overflow: 'hidden',
                    borderLeft: { xs: 'none', md: '2px solid white' },
                    borderBottom: {
                      xs: 'none',
                      md: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none'
                    },
                    borderRight: {
                      xs: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none',
                      md: 'none'
                    },
                    height: { xs: '100px', md: 'auto' },
                    position: 'relative',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleMediaOpen(media.data, media.type, index + 1)}
                >
                  <CardMedia
                    component="img"
                    image={media.data}
                    alt={`Property view ${index + 2}`}
                    sx={{
                      height: '100%',
                      width: '100%',
                      objectFit: 'cover'
                    }}
                  />
                  {index === 2 && remainingMediaCount > 0 && (
                    <Box sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '1.5rem'
                    }}>
                      +{remainingMediaCount}
                    </Box>
                  )}
                </Box>
              ))
            ) : (
              Array.from({ length: 3 }).map((_, index) => (
                <Box
                  key={`empty-${index}`}
                  sx={{
                    flex: 1,
                    backgroundColor: '#f0f0f0',
                    borderLeft: { xs: 'none', md: '2px solid white' },
                    borderBottom: {
                      xs: 'none',
                      md: index !== 2 ? '2px solid white' : 'none'
                    },
                    borderRight: {
                      xs: index !== 2 ? '2px solid white' : 'none',
                      md: 'none'
                    },
                    height: { xs: '100px', md: 'auto' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    No Media
                  </Typography>
                </Box>
              ))
            )}
          </Box>
        </Box>

        <CardContent sx={{ p: 2 }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1
          }}>
            <Typography variant="h5" component="div" sx={{
              fontWeight: '600',
              color: '#3366CC',
              fontFamily: 'Outfit'
            }}>
              {propertyData.price}
            </Typography>
            <Button
              variant="contained"
              onClick={() => handleEditProperty('listing')}
              sx={{
                bgcolor: '#4285F4',
                borderRadius: 2,
                textTransform: 'none',
                px: 2,
                py: 0.5,
                fontSize: '0.875rem',
                fontFamily: 'Outfit'
              }}
            >
              Edit Listing
            </Button>
          </Box>

          <Typography variant="h6" component="div" sx={{
            fontWeight: '500',
            mb: 1,
            fontFamily: 'Outfit'
          }}>
            {propertyData.title}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <LocationOnIcon sx={{
              color: 'text.secondary',
              fontSize: 18,
              mr: 0.5,
              fontWeight: '400'
            }} />
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
              {propertyData.location}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
              <CalendarTodayIcon sx={{
                color: 'text.secondary',
                fontSize: 18,
                mr: 0.5,
                fontWeight: '400'
              }} />
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                {propertyData.date}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <VisibilityIcon sx={{
                color: 'text.secondary',
                fontSize: 18,
                mr: 0.5,
                fontWeight: '400'
              }} />
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                {propertyData.views}
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={2}>
            {hasValue(property?.bhk) && (
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <HotelIcon sx={{
                    color: 'text.secondary',
                    fontSize: 20,
                    mr: 1,
                    fontWeight: '400'
                  }} />
                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                    {propertyData.beds} Beds
                  </Typography>
                </Box>
              </Grid>
            )}
            {hasValue(property?.bathrooms) && (
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <BathtubIcon sx={{
                    color: 'text.secondary',
                    fontSize: 20,
                    mr: 1,
                    fontWeight: '400'
                  }} />
                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                    {propertyData.baths} Baths
                  </Typography>
                </Box>
              </Grid>
            )}
            {hasValue(property?.property_size) && (
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SquareFootIcon sx={{
                    color: 'text.secondary',
                    fontSize: 20,
                    mr: 1,
                    fontWeight: '400'
                  }} />
                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                    {propertyData.area}
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>

          {hasValue(property?.description) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Property Description
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{
                mb: 3,
                fontFamily: 'Outfit'
              }}>
                {propertyData.description}
              </Typography>
            </Box>
          )}

          {hasValue(property?.content) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Additional Content
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{
                mb: 3,
                fontFamily: 'Outfit'
              }}>
                {property.content}
              </Typography>
            </Box>
          )}

          {hasValue(property?.full_address) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Complete Address
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{
                mb: 3,
                fontFamily: 'Outfit'
              }}>
                {property.full_address}
              </Typography>
            </Box>
          )}

          {hasValue(property?.youtube_link) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Property Video
              </Typography>
              <a
                href={property.youtube_link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#4285F4',
                  textDecoration: 'none',
                  fontFamily: 'Outfit'
                }}
              >
                Watch on YouTube
              </a>
            </Box>
          )}

          {property?.asset_type === 'Apartment' && (hasValue(property?.carpet_area) || hasValue(property?.built_up_area)) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Area Details
              </Typography>
              <Grid container spacing={2}>
                {hasValue(property?.carpet_area) && (
                  <Grid item xs={12} md={6}>
                    <Box sx={{
                      p: 2,
                      bgcolor: '#f8f9fa',
                      borderRadius: 2,
                      border: '1px solid #e0e0e0'
                    }}>
                      <Typography variant="body2" color="text.secondary" sx={{
                        mb: 0.5,
                        fontFamily: 'Outfit'
                      }}>
                        Carpet Area
                      </Typography>
                      <Typography variant="h6" sx={{
                        fontWeight: '500',
                        fontFamily: 'Outfit'
                      }}>
                        {property.carpet_area} {property.carpet_area_units}
                      </Typography>
                    </Box>
                  </Grid>
                )}
                {hasValue(property?.built_up_area) && (
                  <Grid item xs={12} md={6}>
                    <Box sx={{
                      p: 2,
                      bgcolor: '#f8f9fa',
                      borderRadius: 2,
                      border: '1px solid #e0e0e0'
                    }}>
                      <Typography variant="body2" color="text.secondary" sx={{
                        mb: 0.5,
                        fontFamily: 'Outfit'
                      }}>
                        Built-up Area
                      </Typography>
                      <Typography variant="h6" sx={{
                        fontWeight: '500',
                        fontFamily: 'Outfit'
                      }}>
                        {property.built_up_area} {property.built_up_area_units}
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          )}

          {shouldShowAmenities() && allAmenities.length > 0 && (
            <Box sx={{ mt: 3 }}>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2
              }}>
                <Typography variant="h6" component="div" sx={{
                  fontWeight: '500',
                  fontFamily: 'Outfit'
                }}>
                  Features & Amenities
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => handleEditProperty('amenities')}
                  sx={{
                    bgcolor: '#4285F4',
                    borderRadius: 2,
                    textTransform: 'none',
                    px: 2,
                    py: 0.5,
                    fontSize: '0.875rem',
                    fontFamily: 'Outfit'
                  }}
                >
                  Manage Amenities
                </Button>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  {allAmenities.slice(0, 8).map((amenity, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 2
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px solid #e0e0e0',
                          borderRadius: '4px',
                          p: 0.5,
                          mr: 1.5,
                          width: 32,
                          height: 32
                        }}>
                        {getAmenityIcon(amenity)}
                      </Box>
                      <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>{amenity}</Typography>
                    </Box>
                  ))}
                </Grid>
                {allAmenities.length > 8 && (
                  <Grid item xs={12} md={6}>
                    {allAmenities.slice(8).map((amenity, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          mb: 2
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid #e0e0e0',
                            borderRadius: '4px',
                            p: 0.5,
                            mr: 1.5,
                            width: 32,
                            height: 32
                          }}>
                          {getAmenityIcon(amenity)}
                        </Box>
                        <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>{amenity}</Typography>
                      </Box>
                    ))}
                  </Grid>
                )}
              </Grid>
            </Box>
          )}

          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" component="div" sx={{
              fontWeight: '500',
              mb: 2,
              fontFamily: 'Outfit'
            }}>
              Additional details
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', py: 1.5 }}>
                <Typography variant="body2" color="text.secondary" sx={{
                  width: '150px',
                  fontFamily: 'Outfit'
                }}>
                  Property type
                </Typography>
                <Typography variant="body2" sx={{
                  fontWeight: '500',
                  fontFamily: 'Outfit'
                }}>
                  {propertyData.propertyType}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', py: 1.5 }}>
                <Typography variant="body2" color="text.secondary" sx={{
                  width: '150px',
                  fontFamily: 'Outfit'
                }}>
                  Property ID
                </Typography>
                <Typography variant="body2" sx={{
                  fontWeight: '500',
                  fontFamily: 'Outfit'
                }}>
                  {propertyData.propertyID}
                </Typography>
              </Box>
              {hasValue(property?.negotiable) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Price Negotiable
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    textTransform: 'capitalize'
                  }}>
                    {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.total_floors) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Total Floors
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {property.total_floors}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.select_floor) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Floor Number
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {property.select_floor}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.furnish_type) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Furnishing
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    textTransform: 'capitalize'
                  }}>
                    {property.furnish_type.replace(/-/g, ' ')}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.construction_status) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Construction Status
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    textTransform: 'capitalize'
                  }}>
                    {property.construction_status}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.monthly_rent) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Monthly Rent
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {formatCurrency(property.monthly_rent, property.currency)}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.security_deposit) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Security Deposit
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {property.security_deposit}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.available_from) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Available From
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {formatDate(property.available_from)}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.length) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Length
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {property.length} {property.property_size_units}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.width) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Width
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {property.width} {property.property_size_units}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.ownership) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Ownership
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    textTransform: 'capitalize'
                  }}>
                    {property.ownership}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.hub) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Hub
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit'
                  }}>
                    {property.hub}
                  </Typography>
                </Box>
              )}
              {hasValue(property?.commercial_catgory) && (
                <Box sx={{ display: 'flex', py: 1.5 }}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    width: '150px',
                    fontFamily: 'Outfit'
                  }}>
                    Category
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    textTransform: 'capitalize'
                  }}>
                    {property.commercial_catgory}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          <Box sx={{ mt: 4 }}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 3
            }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                fontFamily: 'Outfit'
              }}>
                Contact Information
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Box
                component="div"
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  bgcolor: '#f0f0f0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mr: 2,
                  overflow: 'hidden'
                }}
              >
                <img
                  src={userProfile.profile_image || "https://propertydealstalk.com/api/portraits/men/32.jpg"}
                  alt="Profile"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </Box>
              <Box>
                <Typography variant="subtitle1" sx={{
                  fontWeight: '500',
                  fontFamily: 'Outfit',
                  mb: 1
                }}>
                  {userProfile.full_name || propertyData.seller.full_name}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <PhoneIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                    <Typography variant="body2" sx={{ fontFamily: 'Outfit', color: 'blue' }}>
                      {userProfile.contact_number || propertyData.seller.contact_number}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <EmailIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1 }} />
                    <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>
                      {userProfile.email_id || propertyData.seller.email_id}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Media Dialog with Navigation */}
      <Dialog
        open={mediaDialogOpen}
        onClose={handleMediaClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ position: 'relative', p: 0, backgroundColor: 'black' }}>
          <IconButton
            aria-label="close"
            onClick={handleMediaClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white',
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>

          <IconButton
            aria-label="previous media"
            onClick={() => handlePrevMedia(allMedia)}
            disabled={currentMediaIndex === 0}
            sx={{
              position: 'absolute',
              left: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'white',
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              opacity: currentMediaIndex === 0 ? 0.5 : 1,
              visibility: currentMediaIndex === 0 ? 'hidden' : 'visible',
            }}
          >
            <ChevronLeftIcon fontSize="large" />
          </IconButton>

          <IconButton
            aria-label="next media"
            onClick={() => handleNextMedia(allMedia)}
            disabled={currentMediaIndex === allMedia.length - 1}
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'white',
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              opacity: currentMediaIndex === allMedia.length - 1 ? 0.5 : 1,
              visibility: currentMediaIndex === allMedia.length - 1 ? 'hidden' : 'visible',
            }}
          >
            <ChevronRightIcon fontSize="large" />
          </IconButton>

          <Box sx={{
            position: 'absolute',
            bottom: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            color: 'white',
            zIndex: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '4px 12px',
            borderRadius: 16,
            fontSize: '14px',
          }}>
            {currentMediaIndex + 1} / {allMedia.length}
          </Box>

          <img
            src={selectedMedia}
            alt="Property"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '80vh',
              objectFit: 'contain'
            }}
          />
        </DialogContent>
      </Dialog>

      {/* Photos Management Dialog */}
      <Dialog
        open={photosDialogOpen}
        onClose={() => setPhotosDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          Manage Property Photos
          <IconButton onClick={() => setPhotosDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box>
            <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                component="label"
                startIcon={<AddPhotoAlternateIcon />}
                sx={{
                  bgcolor: '#4285F4',
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 3,
                  py: 1,
                  fontSize: '0.875rem'
                }}
                disabled={uploadedPhotos.length >= 10}
              >
                Add Photos
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileUpload(e)}
                />
              </Button>
            </Box>

            {uploadedPhotos.length >= 10 && (
              <Typography
                variant="caption"
                color="error"
                align="center"
                sx={{ display: 'block', mb: 2 }}
              >
                Maximum limit of 10 images reached
              </Typography>
            )}

            <Grid container spacing={2}>
              {uploadedPhotos.map((photo) => (
                <Grid item xs={12} sm={6} md={4} key={photo.id}>
                  <Box sx={{
                    position: 'relative',
                    borderRadius: 2,
                    overflow: 'hidden',
                    height: 180
                  }}>
                    <img
                      src={photo.preview}
                      alt={photo.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        bgcolor: 'rgba(0,0,0,0.5)',
                        color: 'white',
                        '&:hover': {
                          bgcolor: 'rgba(0,0,0,0.7)'
                        }
                      }}
                      onClick={() => handleDeleteMedia(photo.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                    {photo.isNew && (
                      <Chip
                        label="New"
                        size="small"
                        sx={{
                          position: 'absolute',
                          top: 8,
                          left: 8,
                          backgroundColor: '#4285F4',
                          color: 'white',
                          fontSize: '10px',
                          height: '20px'
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>

            {uploadedPhotos.length === 0 && (
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#f5f5f5',
                borderRadius: 2,
                p: 4,
                mt: 2
              }}>
                <CloudUploadIcon sx={{ fontSize: 60, color: '#bdbdbd', mb: 2 }} />
                <Typography variant="body1" color="text.secondary" align="center">
                  No photos uploaded yet. Click "Add Photos" to upload property images.
                </Typography>
                <Typography variant="caption" color="text.secondary" align="center" sx={{ mt: 1 }}>
                  Maximum 10 images allowed. Backend handles file size validation.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={() => setPhotosDialogOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3
            }}
            disabled={isUploading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveMedia}
            variant="contained"
            color="primary"
            disabled={isUploading || (uploadedPhotos.filter(p => p.isNew).length === 0 && imagesToDelete.length === 0)}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              bgcolor: '#4285F4',
              '&:hover': {
                bgcolor: '#3367d6',
              }
            }}
          >
            {isUploading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={20} sx={{ color: 'white' }} />
                <span>Saving...</span>
              </Box>
            ) : (
              'Save Photos'
            )}
          </Button>
        </DialogActions>
        {isUploading && <Loader />}
      </Dialog>

      {/* Edit Listing Dialog */}
      <Dialog
        open={editListingDialogOpen}
        onClose={() => setEditListingDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          Edit Property Listing
          <IconButton onClick={() => setEditListingDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {/* Basic Details Section */}
            <Paper elevation={0} sx={{ p: 2 }}>
              <Box sx={{
                borderLeft: '4px solid #4285F4',
                pl: 2,
                mb: 3,
                py: 0.5,
                backgroundColor: '#f5f8ff',
                width: '100%',
                textAlign: 'left'
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  fontFamily: 'Outfit',
                  color: '#333'
                }}>
                  Basic Details
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {/* Property Name */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Property Name"
                    name="property_name"
                    value={editedProperty?.property_name || ''}
                    onChange={handleInputChange}
                    variant="outlined"
                    sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}
                    placeholder="Enter property name"
                  />
                </Grid>

                {/* Location */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Location"
                    name="location"
                    value={editedProperty?.location || ''}
                    onChange={handleInputChange}
                    variant="outlined"
                    sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}
                    placeholder="Enter location (city)"
                  />
                </Grid>

                {/* Area Name */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Area Name"
                    name="area_name"
                    value={editedProperty?.area_name || ''}
                    onChange={handleInputChange}
                    variant="outlined"
                    sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}
                    placeholder="Enter area or locality name"
                  />
                </Grid>

                {/* Property Type - DISABLED */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Property Type"
                    value={editedProperty?.property_type || ''}
                    variant="outlined"
                    disabled
                    sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px',
                        backgroundColor: '#f5f5f5'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}
                  />
                </Grid>

                {/* Asset Type - DISABLED */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Asset Type"
                    value={editedProperty?.asset_type || ''}
                    variant="outlined"
                    disabled
                    sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px',
                        backgroundColor: '#f5f5f5'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}
                  />
                </Grid>

                {/* Category - DISABLED */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Category"
                    value={editedProperty?.category || ''}
                    variant="outlined"
                    disabled
                    sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px',
                        backgroundColor: '#f5f5f5',
                        textTransform: 'capitalize'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}
                  />
                </Grid>

                {/* Furnish Type */}
                {hasValue(property?.furnish_type) && (
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}>
                      <InputLabel>Furnish Type</InputLabel>
                      <Select
                        name="furnish_type"
                        value={editedProperty?.furnish_type || ''}
                        onChange={handleInputChange}
                        label="Furnish Type"
                      >
                        <MenuItem value="fully">Fully Furnished</MenuItem>
                        <MenuItem value="semi">Semi Furnished</MenuItem>
                        <MenuItem value="unfurnished">Unfurnished</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {/* Full Address */}
                {hasValue(property?.full_address) && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Complete Address"
                      name="full_address"
                      value={editedProperty?.full_address || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      multiline
                      rows={2}
                      sx={{ mb: 2 }}
                      placeholder="Enter complete address with landmark"
                    />
                  </Grid>
                )}

                {/* YouTube Link */}
                {hasValue(property?.youtube_link) && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="YouTube Link"
                      name="youtube_link"
                      value={editedProperty?.youtube_link || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Enter YouTube video link"
                    />
                  </Grid>
                )}
              </Grid>
            </Paper>

            {/* Price Details Section */}
            <Paper elevation={0} sx={{ p: 2 }}>
              <Box sx={{
                borderLeft: '4px solid #4285F4',
                pl: 2,
                mb: 3,
                py: 0.5,
                backgroundColor: '#f5f8ff',
                width: '100%',
                textAlign: 'left'
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  fontFamily: 'Outfit',
                  color: '#333'
                }}>
                  Price Details
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {/* Asking Price */}
                {(hasValue(property?.asking_price) || property?.category === 'sale') && (
                  <>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label={property?.category === 'rent' ? "Asking Price (Optional)" : "Asking Price"}
                        name="asking_price"
                        type="number"
                        value={editedProperty?.asking_price || ''}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{
                          mb: 2,
                          '& .MuiInputBase-root': {
                            height: '56px'
                          },
                          '& .MuiInputLabel-root': {
                            lineHeight: '1.2'
                          }
                        }}
                        placeholder="Enter price amount"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              {editedProperty?.currency || '₹'}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}>
                        <InputLabel>Currency</InputLabel>
                        <Select
                          name="currency"
                          value={editedProperty?.currency || '₹'}
                          onChange={handleInputChange}
                          label="Currency"
                        >
                          <MenuItem value="₹">₹ (INR)</MenuItem>
                          <MenuItem value="$">$ (USD)</MenuItem>
                          <MenuItem value="€">€ (EUR)</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={editedProperty?.negotiable === 'true' || editedProperty?.negotiable === true}
                            onChange={(e) => setEditedProperty(prev => ({
                              ...prev,
                              negotiable: e.target.checked ? 'true' : 'false'
                            }))}
                            name="negotiable"
                            sx={{ color: '#4285F4' }}
                          />
                        }
                        label="Price is Negotiable"
                        sx={{ fontFamily: 'Outfit' }}
                      />
                    </Grid>
                  </>
                )}

                {/* Monthly Rent */}
                {hasValue(property?.monthly_rent) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Monthly Rent"
                      name="monthly_rent"
                      type="number"
                      value={editedProperty?.monthly_rent || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Enter monthly rent"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {editedProperty?.currency || '₹'}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                )}

                {/* Security Deposit */}
                {hasValue(property?.security_deposit) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Security Deposit"
                      name="security_deposit"
                      value={editedProperty?.security_deposit || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="e.g., 1month, 2months, or amount"
                    />
                  </Grid>
                )}

                {/* Available From */}
                {hasValue(property?.available_from) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Available From"
                      name="available_from"
                      type="date"
                      value={editedProperty?.available_from || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </Paper>

            {/* Property Specifications Section */}
            <Paper elevation={0} sx={{ p: 2 }}>
              <Box sx={{
                borderLeft: '4px solid #4285F4',
                pl: 2,
                mb: 3,
                py: 0.5,
                backgroundColor: '#f5f8ff',
                width: '100%',
                textAlign: 'left'
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  fontFamily: 'Outfit',
                  color: '#333'
                }}>
                  Property Specifications
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {/* BHK */}
                {hasValue(property?.bhk) && (
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="BHK"
                      name="bhk"
                      type="number"
                      value={editedProperty?.bhk || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="No. of bedrooms"
                    />
                  </Grid>
                )}

                {/* Bathrooms */}
                {hasValue(property?.bathrooms) && (
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Bathrooms"
                      name="bathrooms"
                      type="number"
                      value={editedProperty?.bathrooms || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="No. of bathrooms"
                    />
                  </Grid>
                )}

                {/* Property Size */}
                {hasValue(property?.property_size) && (
                  <>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Property Size"
                        name="property_size"
                        type="number"
                        value={editedProperty?.property_size || ''}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{
                          mb: 2,
                          '& .MuiInputBase-root': {
                            height: '56px'
                          },
                          '& .MuiInputLabel-root': {
                            lineHeight: '1.2'
                          }
                        }}
                        placeholder="Enter property size"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}>
                        <InputLabel>Unit</InputLabel>
                        <Select
                          name="property_size_units"
                          value={editedProperty?.property_size_units || ''}
                          onChange={handleInputChange}
                          label="Unit"
                        >
                          <MenuItem value="sq.ft">Square Feet</MenuItem>
                          <MenuItem value="sq.m">Square Meters</MenuItem>
                          <MenuItem value="acres">Acres</MenuItem>
                          <MenuItem value="hectares">Hectares</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}

                {/* Carpet Area */}
                {hasValue(property?.carpet_area) && (
                  <>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Carpet Area"
                        name="carpet_area"
                        type="number"
                        value={editedProperty?.carpet_area || ''}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{
                          mb: 2,
                          '& .MuiInputBase-root': {
                            height: '56px'
                          },
                          '& .MuiInputLabel-root': {
                            lineHeight: '1.2'
                          }
                        }}
                        placeholder="Enter carpet area"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}>
                        <InputLabel>Carpet Area Unit</InputLabel>
                        <Select
                          name="carpet_area_units"
                          value={editedProperty?.carpet_area_units || 'Sq.Ft'}
                          onChange={handleInputChange}
                          label="Carpet Area Unit"
                        >
                          <MenuItem value="Sq.Ft">Sq. Ft</MenuItem>
                          <MenuItem value="Sq.yards">Sq. yards</MenuItem>
                          <MenuItem value="Sq.m">Sq. m</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}

                {/* Built-up Area */}
                {hasValue(property?.built_up_area) && (
                  <>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Built-up Area"
                        name="built_up_area"
                        type="number"
                        value={editedProperty?.built_up_area || ''}
                        onChange={handleInputChange}
                        variant="outlined"
                        sx={{
                          mb: 2,
                          '& .MuiInputBase-root': {
                            height: '56px'
                          },
                          '& .MuiInputLabel-root': {
                            lineHeight: '1.2'
                          }
                        }}
                        placeholder="Enter built-up area"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}>
                        <InputLabel>Built-up Area Unit</InputLabel>
                        <Select
                          name="built_up_area_units"
                          value={editedProperty?.built_up_area_units || 'Sq.Ft'}
                          onChange={handleInputChange}
                          label="Built-up Area Unit"
                        >
                          <MenuItem value="Sq.Ft">Sq. Ft</MenuItem>
                          <MenuItem value="Sq.yards">Sq. yards</MenuItem>
                          <MenuItem value="Sq.m">Sq. m</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}

                {/* Length */}
                {hasValue(property?.length) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Length"
                      name="length"
                      type="number"
                      value={editedProperty?.length || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Enter length"
                    />
                  </Grid>
                )}

                {/* Width */}
                {hasValue(property?.width) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Width"
                      name="width"
                      type="number"
                      value={editedProperty?.width || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Enter width"
                    />
                  </Grid>
                )}

                {/* Total Floors */}
                {hasValue(property?.total_floors) && (
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Total Floors"
                      name="total_floors"
                      type="number"
                      value={editedProperty?.total_floors || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Total floors in building"
                    />
                  </Grid>
                )}

                {/* Floor Number */}
                {hasValue(property?.select_floor) && (
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Floor Number"
                      name="select_floor"
                      type="number"
                      value={editedProperty?.select_floor || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Property floor number"
                    />
                  </Grid>
                )}

                {/* Construction Status */}
                {hasValue(property?.construction_status) && (
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{
                      mb: 2,
                      '& .MuiInputBase-root': {
                        height: '56px'
                      },
                      '& .MuiInputLabel-root': {
                        lineHeight: '1.2'
                      }
                    }}>
                      <InputLabel>Construction Status</InputLabel>
                      <Select
                        name="construction_status"
                        value={editedProperty?.construction_status || ''}
                        onChange={handleInputChange}
                        label="Construction Status"
                      >
                        <MenuItem value="ready to move">Ready to Move</MenuItem>
                        <MenuItem value="under construction">Under Construction</MenuItem>
                        <MenuItem value="new launch">New Launch</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {/* Ownership */}
                {hasValue(property?.ownership) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Ownership"
                      name="ownership"
                      value={editedProperty?.ownership || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="e.g., Freehold, Leasehold"
                    />
                  </Grid>
                )}

                {/* Hub */}
                {hasValue(property?.hub) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Hub/Location Hub"
                      name="hub"
                      value={editedProperty?.hub || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="e.g., Business Park, IT Hub"
                    />
                  </Grid>
                )}

                {/* Commercial Category */}
                {hasValue(property?.commercial_catgory) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Commercial Category"
                      name="commercial_catgory"
                      value={editedProperty?.commercial_catgory || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      disabled
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px',
                          backgroundColor: '#f5f5f5'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Enter commercial category"
                    />
                  </Grid>
                )}

                {/* Commercial Asset Type */}
                {hasValue(property?.commercial_asset_type) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Commercial Asset Type"
                      name="commercial_asset_type"
                      value={editedProperty?.commercial_asset_type || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      disabled
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px',
                          backgroundColor: '#f5f5f5'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Enter asset type"
                    />
                  </Grid>
                )}

                {/* UDS */}
                {hasValue(property?.uds) && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="UDS (Undivided Share)"
                      name="uds"
                      type="number"
                      value={editedProperty?.uds || ''}
                      onChange={handleInputChange}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiInputBase-root': {
                          height: '56px'
                        },
                        '& .MuiInputLabel-root': {
                          lineHeight: '1.2'
                        }
                      }}
                      placeholder="Enter UDS value"
                    />
                  </Grid>
                )}
              </Grid>
            </Paper>

            {/* Description Section */}
            {hasValue(property?.description) && (
              <Paper elevation={0} sx={{ p: 2 }}>
                <Box sx={{
                  borderLeft: '4px solid #4285F4',
                  pl: 2,
                  mb: 3,
                  py: 0.5,
                  backgroundColor: '#f5f8ff',
                  width: '100%',
                  textAlign: 'left'
                }}>
                  <Typography variant="subtitle1" sx={{
                    fontWeight: 600,
                    fontFamily: 'Outfit',
                    color: '#333'
                  }}>
                    Property Description
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  value={editedProperty?.description || ''}
                  onChange={handleInputChange}
                  variant="outlined"
                  multiline
                  rows={4}
                  sx={{ mb: 2 }}
                  placeholder="Describe your property with key features, condition, and surroundings"
                />
              </Paper>
            )}

            {/* Content Section */}
            {hasValue(property?.content) && (
              <Paper elevation={0} sx={{ p: 2 }}>
                <Box sx={{
                  borderLeft: '4px solid #4285F4',
                  pl: 2,
                  mb: 3,
                  py: 0.5,
                  backgroundColor: '#f5f8ff',
                  width: '100%',
                  textAlign: 'left'
                }}>
                  <Typography variant="subtitle1" sx={{
                    fontWeight: 600,
                    fontFamily: 'Outfit',
                    color: '#333'
                  }}>
                    Additional Content
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  label="Content"
                  name="content"
                  value={editedProperty?.content || ''}
                  onChange={handleInputChange}
                  variant="outlined"
                  multiline
                  rows={4}
                  sx={{ mb: 2 }}
                  placeholder="Additional information about the property"
                />
              </Paper>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={() => setEditListingDialogOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleSaveChanges('listing')}
            variant="contained"
            color="primary"
            disabled={isSaving}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              bgcolor: '#4285F4',
              '&:hover': {
                bgcolor: '#3367d6',
              }
            }}
          >
            {isSaving ? <CircularProgress size={24} /> : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Amenities Dialog */}
      <Dialog
        open={amenitiesDialogOpen}
        onClose={() => setAmenitiesDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        fullScreen={window.innerWidth < 600}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: window.innerWidth < 600 ? 0 : '24px',
            maxHeight: window.innerWidth < 600 ? '100vh' : '90vh',
            margin: window.innerWidth < 600 ? 0 : 2,
          }
        }}
      >
        <DialogContent sx={{ p: window.innerWidth < 600 ? 2 : 4, pb: window.innerWidth < 600 ? 10 : 4 }}>
          <Typography
            variant={window.innerWidth < 600 ? "h5" : "h4"}
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 500,
              color: 'black',
              mb: window.innerWidth < 600 ? 2 : 4,
              textAlign: window.innerWidth < 600 ? 'center' : 'left'
            }}
          >
            Add Property Amenities
          </Typography>

          {/* Society Amenities */}
          <Box sx={{ mb: window.innerWidth < 600 ? 3 : 4 }}>
            <Typography
              variant={window.innerWidth < 600 ? "h6" : "h5"}
              sx={{
                fontFamily: 'Outfit',
                fontWeight: 500,
                color: '#666',
                mb: 2,
                fontSize: window.innerWidth < 600 ? '18px' : '24px'
              }}
            >
              Society Amenities
            </Typography>
            <Grid container spacing={window.innerWidth < 600 ? 1.5 : 2}>
              {societyAmenitiesData.map((amenity, index) => {
                const isChecked = editedProperty?.society_aminities ?
                  editedProperty.society_aminities.split(', ').includes(amenity.name) : false;

                return (
                  <Grid item xs={6} sm={4} md={2.4} key={`society-${index}`}>
                    <Card
                      onClick={() => {
                        const currentItems = editedProperty?.society_aminities ?
                          editedProperty.society_aminities.split(', ') : [];

                        let updatedItems;
                        if (isChecked) {
                          updatedItems = currentItems.filter(item => item !== amenity.name);
                        } else {
                          updatedItems = [...currentItems, amenity.name];
                        }

                        setEditedProperty(prev => ({
                          ...prev,
                          society_aminities: updatedItems.filter(item => item).join(', ')
                        }));
                      }}
                      sx={{
                        height: window.innerWidth < 600 ? 100 : 120,
                        cursor: 'pointer',
                        border: isChecked ? '2px solid #4f26ff' : '1px solid #d0d0d0',
                        backgroundColor: isChecked ? '#eeeaff' : 'white',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 1,
                        borderRadius: '12px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          borderColor: '#4f26ff',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
                        },
                        '&:active': {
                          transform: 'translateY(0px)',
                        }
                      }}
                    >
                      <CardContent sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: `${window.innerWidth < 600 ? 6 : 8}px !important`,
                        textAlign: 'center'
                      }}>
                        <Box
                          component="img"
                          src={amenity.icon}
                          alt={amenity.name}
                          sx={{
                            width: window.innerWidth < 600 ? 30 : 40,
                            height: window.innerWidth < 600 ? 30 : 40,
                            mb: 0.5,
                            objectFit: 'contain'
                          }}
                        />
                        <Typography sx={{
                          textAlign: 'center',
                          fontSize: window.innerWidth < 600 ? '12px' : '14px',
                          fontFamily: 'Outfit',
                          color: isChecked ? '#4f26ff' : 'black',
                          fontWeight: isChecked ? 500 : 400,
                          lineHeight: 1.2,
                          wordBreak: 'break-word',
                          hyphens: 'auto'
                        }}>
                          {amenity.name}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>

          {/* Furnishing Facilities */}
          <Box sx={{ mb: window.innerWidth < 600 ? 3 : 4 }}>
            <Typography
              variant={window.innerWidth < 600 ? "h6" : "h5"}
              sx={{
                fontFamily: 'Outfit',
                fontWeight: 500,
                color: '#666',
                mb: 2,
                fontSize: window.innerWidth < 600 ? '18px' : '24px'
              }}
            >
              Furnishing Facilities
            </Typography>
            <Grid container spacing={window.innerWidth < 600 ? 1.5 : 2}>
              {furnishingFacilitiesData.map((facility, index) => {
                const isChecked = editedProperty?.furnish_facilities ?
                  editedProperty.furnish_facilities.split(', ').includes(facility.name) : false;

                return (
                  <Grid item xs={6} sm={4} md={2.4} key={`furnishing-${index}`}>
                    <Card
                      onClick={() => {
                        const currentItems = editedProperty?.furnish_facilities ?
                          editedProperty.furnish_facilities.split(', ') : [];

                        let updatedItems;
                        if (isChecked) {
                          updatedItems = currentItems.filter(item => item !== facility.name);
                        } else {
                          updatedItems = [...currentItems, facility.name];
                        }

                        setEditedProperty(prev => ({
                          ...prev,
                          furnish_facilities: updatedItems.filter(item => item).join(', ')
                        }));
                      }}
                      sx={{
                        height: window.innerWidth < 600 ? 100 : 120,
                        cursor: 'pointer',
                        border: isChecked ? '2px solid #4f26ff' : '1px solid #d0d0d0',
                        backgroundColor: isChecked ? '#eeeaff' : 'white',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 1,
                        borderRadius: '12px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          borderColor: '#4f26ff',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
                        },
                        '&:active': {
                          transform: 'translateY(0px)',
                        }
                      }}
                    >
                      <CardContent sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: `${window.innerWidth < 600 ? 6 : 8}px !important`,
                        textAlign: 'center'
                      }}>
                        <Box
                          component="img"
                          src={facility.icon}
                          alt={facility.name}
                          sx={{
                            width: window.innerWidth < 600 ? 30 : 40,
                            height: window.innerWidth < 600 ? 30 : 40,
                            mb: 0.5,
                            objectFit: 'contain'
                          }}
                        />
                        <Typography sx={{
                          textAlign: 'center',
                          fontSize: window.innerWidth < 600 ? '12px' : '14px',
                          fontFamily: 'Outfit',
                          color: isChecked ? '#4f26ff' : 'black',
                          fontWeight: isChecked ? 500 : 400,
                          lineHeight: 1.2,
                          wordBreak: 'break-word'
                        }}>
                          {facility.name}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>

          {/* Other Facilities */}
          <Box sx={{ mb: window.innerWidth < 600 ? 3 : 4 }}>
            <Typography
              variant={window.innerWidth < 600 ? "h6" : "h5"}
              sx={{
                fontFamily: 'Outfit',
                fontWeight: 500,
                color: '#666',
                mb: 2,
                fontSize: window.innerWidth < 600 ? '18px' : '24px'
              }}
            >
              Other Facilities
            </Typography>
            <Grid container spacing={window.innerWidth < 600 ? 1.5 : 2}>
              {otherFacilitiesData.map((facility, index) => {
                const isChecked = editedProperty?.other_facilities ?
                  editedProperty.other_facilities.split(', ').includes(facility) : false;

                return (
                  <Grid item xs={6} sm={4} md={3} key={`other-facility-${index}`}>
                    <Card
                      onClick={() => {
                        const currentItems = editedProperty?.other_facilities ?
                          editedProperty.other_facilities.split(', ') : [];

                        let updatedItems;
                        if (isChecked) {
                          updatedItems = currentItems.filter(item => item !== facility);
                        } else {
                          updatedItems = [...currentItems, facility];
                        }

                        setEditedProperty(prev => ({
                          ...prev,
                          other_facilities: updatedItems.filter(item => item).join(', ')
                        }));
                      }}
                      sx={{
                        height: window.innerWidth < 600 ? 60 : 70,
                        cursor: 'pointer',
                        border: isChecked ? '2px solid #4f26ff' : '1px solid #d0d0d0',
                        backgroundColor: isChecked ? '#eeeaff' : 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 2,
                        borderRadius: '12px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          borderColor: '#4f26ff',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(79, 38, 255, 0.15)'
                        },
                        '&:active': {
                          transform: 'translateY(0px)',
                        }
                      }}
                    >
                      <CardContent sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: `${window.innerWidth < 600 ? 8 : 12}px !important`,
                        width: '100%'
                      }}>
                        <Typography sx={{
                          textAlign: 'center',
                          fontSize: window.innerWidth < 600 ? '13px' : '15px',
                          fontFamily: 'Outfit',
                          color: isChecked ? '#4f26ff' : 'black',
                          fontWeight: isChecked ? 500 : 400,
                          lineHeight: 1.2,
                          wordBreak: 'break-word'
                        }}>
                          {facility}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{
          p: window.innerWidth < 600 ? 2 : 3,
          justifyContent: window.innerWidth < 600 ? 'center' : 'space-between',
          flexDirection: window.innerWidth < 600 ? 'row' : 'row',
          gap: window.innerWidth < 600 ? 2 : 0,
          position: window.innerWidth < 600 ? 'fixed' : 'relative',
          bottom: window.innerWidth < 600 ? 0 : 'auto',
          left: window.innerWidth < 600 ? 0 : 'auto',
          right: window.innerWidth < 600 ? 0 : 'auto',
          backgroundColor: 'white',
          borderTop: window.innerWidth < 600 ? '1px solid #e0e0e0' : 'none'
        }}>
          <Button
            onClick={() => {
              setAmenitiesDialogOpen(false);
            }}
            variant="contained"
            sx={{
              width: window.innerWidth < 600 ? '50%' : 180,
              height: window.innerWidth < 600 ? 50 : 60,
              bgcolor: '#c2c2c2',
              borderRadius: '10px',
              border: '1px solid #d0d0d0',
              color: '#020202',
              fontSize: window.innerWidth < 600 ? 16 : 18,
              fontFamily: "'Outfit', Helvetica",
              fontWeight: 'normal',
              order: 1,
              '&:hover': {
                bgcolor: '#b0b0b0'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleSaveChanges('amenities')}
            variant="contained"
            disabled={isSaving}
            sx={{
              width: window.innerWidth < 600 ? '50%' : 180,
              height: window.innerWidth < 600 ? 50 : 60,
              bgcolor: '#4f26ff',
              borderRadius: '10px',
              color: 'white',
              fontSize: window.innerWidth < 600 ? 16 : 18,
              fontFamily: "'Outfit', Helvetica",
              fontWeight: 'normal',
              order: 2,
              '&:hover': {
                bgcolor: '#3d1fd9'
              }
            }}
          >
            {isSaving ? <CircularProgress size={24} color="inherit" /> : 'OK'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alert Dialog */}
      <Dialog
        open={alertDialog.open}
        onClose={handleAlertClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          color: alertDialog.severity === 'success' ? '#2e7d32' : '#d32f2f',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          {alertDialog.severity === 'success' ? 'Success' : 'Error'}
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 1 }}>
          <DialogContentText>
            {alertDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleAlertClose}
            variant="contained"
            color={alertDialog.severity === 'success' ? 'primary' : 'error'}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditProperties;